<template>
  <div class="createViewDP">
    <v-LeftSource> </v-LeftSource>
    <div class="main">
      <div class="dataDiy">
        <span :class="{dataPage:dataPage==1}" @click="goPZ()">数据配置</span>
        <span :class="{dataPage:dataPage==2}" @click="goFX()">对比分析</span>
        <span :class="{dataPage:dataPage==3}" @click="goTS()">数据透视</span>
      </div>
      <div v-if="dataPage==1">
        <div class="leftViewDP">
          <div class="leftTil">
            <FSpanTil title="数据准备" fontSize="16">{{ViewDP.activeView.dataSetName}}</FSpanTil>
            <div class="divSvg" v-if="type !== '修改'">
              <FSvg title="刷新" color="#666" IconSize="22" @click.native="getViewDPDialog(0)"></FSvg>
            </div>
          </div>
          <div class="leftList">
            <div class="list_til noSelect">
              <div class="divSvg">
                <FSvg title="字段" color="#fff" hoverColor="#fff" IconSize="22"></FSvg>
              </div>
              <span class="divSpan">字段</span>
            </div>
            <div class="listUl_count" v-loading="ViewDP.load">
              <ul class="listUl" v-if="ViewDP.list.length">
                <li v-for="item in ViewDP.list" draggable @dragstart="getDragStart(item,$event)" @dragend="dropWDS={type:'',name:'',init:'',startType:-1}" :class="{glClass:item.wd||item.dl}">
                  <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
                  <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
                  <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
                  <span class="name_fie">{{item.field}}</span>
                  <span class="WDMark" v-if="item.wd&&!item.dl">维</span>
                  <span class="WDMark" v-if="item.dl&&!item.wd">度</span>
                  <span class="WDMark" v-if="item.dl&&item.wd">共</span>
                </li>
              </ul>
              <div class="comNoData" v-else><span>暂无数据</span></div>
            </div>
          </div>
          <div class="leftList">
            <div class="list_til noSelect">
              <div class="divSvg">
                <FSvg title="加" color="#fff" hoverColor="#fff" IconSize="22" @click.native="getRefineDPDialog(0)"></FSvg>
              </div>
              <span class="divSpan">联机分析字段</span>
            </div>
            <div class="listUl_count" v-loading="ViewDP.load">
              <ul class="listUl">
                <li v-for="(item,index) in ViewDP.ColumnList" :key="item.index" @click="change(index)" draggable @dragstart="getDragStartML(item,$event)" @dragend="dropWDS={name:'',init:'',startType:-1}" :class="{glClass:item.wd}">
                  <FSvg title="字符" color="#13B5B1" IconSize="20"></FSvg>
                  <span class="name_fie">{{item.menuName}}</span>
                  <span class="WDMark" v-if="item.wd">维</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="cenViewDP" id="cenViewDP">
          <div class="tpCon">
            <div class="tpCon_WL">
              <div class="tpConWD" id="ViewDP_wd" @dragover="getDragOver($event)" @drop="getDrag(0,$event)">
                <p>维度：</p>
                <div class="div_for" v-for="(item,index) in setChart.wdList" @click="getWDDialog(0,item)" draggable @dragstart="getDivDrag(0,0,index,$event)" :id="'view_wdDiv_'+index" @dragend="getDivDrag(0,1,index,$event)">
                  <span v-if="!item.config.alias">{{item.name}}</span>
                  <span v-if="item.config.alias">{{item.config.alias}}</span>
                  <span class="order_div" v-if="item.config.calc!=='默认'">({{item.config.calc}})</span>
                  <span class="order_div" v-if="item.config.order!=='默认'">({{item.config.order}})</span>
                </div>
              </div>
              <div class="tpConDL" id="ViewDP_dl" @dragover="getDragOver($event)" @drop="getDrag(1,$event)">
                <p>度量：</p>
                <div class="div_for" v-for="(item,index) in setChart.dlList" @click="getDLDialog(0,item)" draggable @dragstart="getDivDrag(1,0,index,$event)" :id="'view_dlDiv_'+index" @dragend="getDivDrag(1,1,index,$event)">
                  <span v-if="!item.config.alias">{{item.name}}</span>
                  <span v-if="item.config.alias">{{item.config.alias}}</span>
                  <span class="order_div" v-if="item.config.calc!=='默认'">({{item.config.calc}})</span>
                  <span class="order_div" v-if="item.config.order!=='默认'">({{item.config.order}})</span>
                  <span class="order_div" v-if="item.params.stack">
                    {{'('+item.params.stack+')'}}</span>
                  <span class="order_div" v-if="nowChart.name==='双轴图'">
                    {{item.params.lTAxis===1?'(次)':(item.params.lTAxis===0?'(主)':'')}}</span>
                </div>
              </div>
            </div>
            <div class="tpConSX" id="ViewDP_sx" @dragover="getDragOver($event)" @drop="getDrag(2,$event)">
              <p>筛选：</p>
              <div v-for="(item,index) in setChart.sxList" @click="getSXDialog(0,item)" draggable @dragstart="getDivDrag(2,0,index,$event)" :id="'view_sxDiv_'+index" @dragend="getDivDrag(2,1,index,$event)">
                <span>{{item.name}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="bmCharts" v-loading="state.viewDP.load" id="bmCharts"> -->
          <div class="bmCharts" id="bmCharts">
            <div id="img_canvas_viewDp">
              <viewChart></viewChart>
            </div>
          </div>
          <div class="bmPrompt">
            提示:{{cenBmPrompt||'--'}}
            <div class="save_div">
              <FBtn title="取消" type="2" @click="noSave"></FBtn>
              <FBtn title="保存" type="1" @click="getSave" :disabled="this.state.viewDP.noData"></FBtn>
            </div>
          </div>

        </div>
        <div class="rigViewDP" id="rigViewDP" style="right:10px">
          <div class="two">
            <span>
              <FSvg title="右双箭头" color="#fff" hoverColor="#fff" IconSize="15" @click.native="suofang()"></FSvg>
            </span>
          </div>

          <div class="rigViewDP_til">
            <span :class="{addSpan_til:rigConfig.type===0}" @click="rigConfig.type=0">多维图表</span>
            <span :class="{addSpan_til:rigConfig.type===1}" @click="rigConfig.type=1">图表配置</span>
          </div>
          <div class="rigViewDP_count">
            <div class="config_div config_div_left" v-if="rigConfig.type===0">
              <div class="conLef_top">
                <el-scrollbar :native="false">
                  <el-popover :ref="'popover_'+item.type" popper-class="createViewDP_pop_chart_chil" placement="left" :close-delay="50" :open-delay="100" trigger="hover" v-for="(item,index) in rigConfig.list" :disabled="setChart.wdList.length<item.minWDLength||setChart.dlList.length<item.minDLLength||
                                        setChart.wdList.length>item.maxWDLength||setChart.dlList.length>item.maxDLLength">
                    <div class="chart_d" slot="reference" :class="{addCharts:item.type===charts.type,chart_d_disble:setChart.wdList.length<item.minWDLength||setChart.dlList.length<item.minDLLength||
                                        setChart.wdList.length>item.maxWDLength||setChart.dlList.length>item.maxDLLength}">
                      <img :src="chartsimgUrl +`${item.icon}`" ondragstart="return false">
                      <span>{{item.name}}</span>
                    </div>
                    <div class="chart_chil">
                      <div class="chart_d" v-for="i in item.chil" @click="getClickCharts(item.type,i.name)" :class="{addCharts:i.name===charts.name}">
                        <img :src="chartsimgUrl +`${i.ordImg}`" ondragstart="return false">
                        <span>{{i.name}}</span>
                      </div>
                    </div>
                  </el-popover>
                </el-scrollbar>
              </div>
              <div class="conLef_bom">
                <p>至少<span>{{state.viewDP.chart.option.minWDLength||0}}</span>个维度,最多<span>{{state.viewDP.chart.option.maxWDLength||0}}</span>个维度
                </p>
                <p>至少<span>{{state.viewDP.chart.option.minDLLength||0}}</span>个度量,最多<span>{{state.viewDP.chart.option.maxDLLength||0}}</span>个度量
                </p>
              </div>
            </div>
            <div class="config_div scrollBar_view_xy config_div_rig" v-if="rigConfig.type===1">
              <div class="config_div_rig_div">
                <div class="configFlot">
                  <div class="comDP_config">
                    <div class="config_comTop">
                      <span class="btSpan">多维分析名称</span>
                      <el-input v-model="rigConfig.reportName" placeholder="请输入多维分析名称"></el-input>
                    </div>
                    <div class="config_comTop">
                      <span>图表名称</span>
                      <el-input v-model="nowChart.chartName" placeholder="请输入图表名称"></el-input>
                    </div>
                  </div>
                  <FFoldBox name="公共配置" v-if="charts.showComPonent">
                    <comChart type="view"></comChart>
                  </FFoldBox>
                  <FFoldBox :name="item.name" v-for="item in charts.component" v-if="item.show">
                    <component :is="item.component" type="view" class="div_count"></component>
                  </FFoldBox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="dataPage==2">
        <div class="leftViewDP">
          <div class="leftTil">
            <FSpanTil title="数据准备" fontSize="16">{{ViewDP.activeView.dataSetName}}</FSpanTil>
            <div class="divSvg" v-if="type !== '修改'">
              <FSvg title="刷新" color="#666" IconSize="22" @click.native="getViewDPDialog(0)"></FSvg>
            </div>
          </div>
          <div class="leftList">
            <div class="list_til noSelect">
              <div class="divSvg">
                <FSvg title="字段" color="#fff" hoverColor="#fff" IconSize="22"></FSvg>
              </div>
              <span class="divSpan">字段</span>
            </div>
            <div class="listUl_count" v-loading="ViewDP.load">
              <ul class="listUl" v-if="ViewDP.list.length">
                <li v-for="item in ViewDP.list" draggable @dragstart="getDragStart(item,$event)" @dragend="dropWDS={type:'',name:'',init:'',startType:-1}" :class="{glClass:item.wd||item.dl}">
                  <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
                  <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
                  <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
                  <span class="name_fie">{{item.field}}</span>
                  <span class="WDMark" v-if="item.wd&&!item.dl">维</span>
                  <span class="WDMark" v-if="item.dl&&!item.wd">度</span>
                  <span class="WDMark" v-if="item.dl&&item.wd">共</span>
                </li>
              </ul>
              <div class="comNoData" v-else><span>暂无数据</span></div>
            </div>
          </div>
          <div class="leftList">
            <div class="list_til noSelect">
              <div class="divSvg">
                <FSvg title="加" color="#fff" hoverColor="#fff" IconSize="22" @click.native="getRefineDPDialog(0)"></FSvg>
              </div>
              <span class="divSpan">联机分析字段</span>
            </div>
            <div class="listUl_count" v-loading="ViewDP.load">
              <ul class="listUl">
                <li v-for="(item,index) in ViewDP.ColumnList" :key="item.index" @click="change(index)" draggable @dragstart="getDragStartML(item,$event)" @dragend="dropWDS={name:'',init:'',startType:-1}" :class="{glClass:item.wd}">
                  <FSvg title="字符" color="#13B5B1" IconSize="20"></FSvg>
                  <span class="name_fie">{{item.menuName}}</span>
                  <span class="WDMark" v-if="item.wd">维</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="cenViewDP" id="cenViewDP">
          <div class="tpCon">
            <div class="compareKind">
              <div class="kind">
                <span class="type">对比类型</span>
                <el-radio-group v-model="radio" @change="radioChange()">
                  <el-radio label="1">环比</el-radio>
                  <el-radio label="2">同比</el-radio>
                </el-radio-group>
              </div>
              <div class="cycle">
                <div>观测周期</div>
                <el-select v-model="options1" clearable placeholder="请选择" @change="lookCycle()">
                  <el-option v-for="item in optionsList1" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="cycle" v-if="radio==2">
                <div>观测时期</div>
                <el-date-picker v-model="value1" :type="pickerType" placeholder="选择日期" :value-format="pickerFormat" :format="pickerFormat" @change="lookCycle2()">
                </el-date-picker>
              </div>
              <div class="cycle">
                <div>分析类型</div>
                <el-select v-model="options2" clearable placeholder="请选择" @change="lookCycle3()">
                  <el-option v-for="item in optionsList2" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="tpCon_WL">
              <div class="tpConWD" id="ViewDP_wd" @dragover="getDragOver($event)" @drop="getDrag(0,$event)">
                <p>维度：</p>
                <div class="div_for" v-for="(item,index) in setChart.wdList" @click="getWDDialog(0,item)" draggable @dragstart="getDivDrag(0,0,index,$event)" :id="'view_wdDiv_'+index" @dragend="getDivDrag(0,1,index,$event)">
                  <span v-if="!item.config.alias">{{item.name}}</span>
                  <span v-if="item.config.alias">{{item.config.alias}}</span>
                  <span class="order_div" v-if="item.config.calc!=='默认'">({{item.config.calc}})</span>
                  <span class="order_div" v-if="item.config.order!=='默认'">({{item.config.order}})</span>
                </div>
              </div>
              <div class="tpConDL" id="ViewDP_dl" @dragover="getDragOver($event)" @drop="getDrag(1,$event)">
                <p>度量：</p>
                <div class="div_for" v-for="(item,index) in setChart.dlList" @click="getDLDialog(0,item)" draggable @dragstart="getDivDrag(1,0,index,$event)" :id="'view_dlDiv_'+index" @dragend="getDivDrag(1,1,index,$event)">
                  <span v-if="!item.config.alias">{{item.name}}</span>
                  <span v-if="item.config.alias">{{item.config.alias}}</span>
                  <span class="order_div" v-if="item.config.calc!=='默认'">({{item.config.calc}})</span>
                  <span class="order_div" v-if="item.config.order!=='默认'">({{item.config.order}})</span>
                  <span class="order_div" v-if="item.params.stack">
                    {{'('+item.params.stack+')'}}</span>
                  <span class="order_div" v-if="nowChart.name==='双轴图'">
                    {{item.params.lTAxis===1?'(次)':(item.params.lTAxis===0?'(主)':'')}}</span>
                </div>
              </div>
            </div>
            <div class="tpConSX" id="ViewDP_sx" @dragover="getDragOver($event)" @drop="getDrag(2,$event)">
              <p>筛选：</p>
              <div v-for="(item,index) in setChart.sxList" @click="getSXDialog(0,item)" draggable @dragstart="getDivDrag(2,0,index,$event)" :id="'view_sxDiv_'+index" @dragend="getDivDrag(2,1,index,$event)">
                <span>{{item.name}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="bmCharts" v-loading="state.viewDP.load" id="bmCharts"> -->
          <div class="bmCharts" id="bmCharts">
            <div id="img_canvas_viewDp">
              <viewChart></viewChart>
            </div>
          </div>
          <div class="bmPrompt">
            提示:{{cenBmPrompt||'--'}}
            <div class="save_div">
              <FBtn title="取消" type="2" @click="noSave"></FBtn>
              <FBtn title="保存" type="1" @click="getSave" :disabled="this.state.viewDP.noData"></FBtn>
            </div>
          </div>

        </div>
        <div class="rigViewDP" id="rigViewDP" style="right:10px">
          <div class="two">
            <span>
              <FSvg title="右双箭头" color="#fff" hoverColor="#fff" IconSize="15" @click.native="suofang()"></FSvg>
            </span>
          </div>

          <div class="rigViewDP_til">
            <span :class="{addSpan_til:rigConfig.type===0}" @click="rigConfig.type=0">多维图表</span>
            <span :class="{addSpan_til:rigConfig.type===1}" @click="rigConfig.type=1">图表配置</span>
          </div>
          <div class="rigViewDP_count">
            <div class="config_div config_div_left" v-if="rigConfig.type===0">
              <div class="conLef_top">
                <el-scrollbar :native="false">
                  <el-popover :ref="'popover_'+item.type" popper-class="createViewDP_pop_chart_chil" placement="left" :close-delay="50" :open-delay="100" trigger="hover" v-for="(item,index) in rigConfig.list" :disabled="setChart.wdList.length<item.minWDLength||setChart.dlList.length<item.minDLLength||
                                        setChart.wdList.length>item.maxWDLength||setChart.dlList.length>item.maxDLLength">
                    <div class="chart_d" slot="reference" :class="{addCharts:item.type===charts.type,chart_d_disble:setChart.wdList.length<item.minWDLength||setChart.dlList.length<item.minDLLength||
                                        setChart.wdList.length>item.maxWDLength||setChart.dlList.length>item.maxDLLength}">
                      <img :src="chartsimgUrl +`${item.icon}`" ondragstart="return false">
                      <span>{{item.name}}</span>
                    </div>
                    <div class="chart_chil">
                      <div class="chart_d" v-for="i in item.chil" @click="getClickCharts(item.type,i.name)" :class="{addCharts:i.name===charts.name}">
                        <img :src="chartsimgUrl +`${i.ordImg}`" ondragstart="return false">
                        <span>{{i.name}}</span>
                      </div>
                    </div>
                  </el-popover>
                </el-scrollbar>
              </div>
              <div class="conLef_bom">
                <p>至少<span>{{state.viewDP.chart.option.minWDLength||0}}</span>个维度,最多<span>{{state.viewDP.chart.option.maxWDLength||0}}</span>个维度
                </p>
                <p>至少<span>{{state.viewDP.chart.option.minDLLength||0}}</span>个度量,最多<span>{{state.viewDP.chart.option.maxDLLength||0}}</span>个度量
                </p>
              </div>
            </div>
            <div class="config_div scrollBar_view_xy config_div_rig" v-if="rigConfig.type===1">
              <div class="config_div_rig_div">
                <div class="configFlot">
                  <div class="comDP_config">
                    <div class="config_comTop">
                      <span class="btSpan">多维分析名称</span>
                      <el-input v-model="rigConfig.reportName" placeholder="请输入多维分析名称"></el-input>
                    </div>
                    <div class="config_comTop">
                      <span>图表名称</span>
                      <el-input v-model="nowChart.chartName" placeholder="请输入图表名称"></el-input>
                    </div>
                  </div>
                  <FFoldBox name="公共配置" v-if="charts.showComPonent">
                    <comChart type="view"></comChart>
                  </FFoldBox>
                  <FFoldBox :name="item.name" v-for="item in charts.component" v-if="item.show">
                    <component :is="item.component" type="view" class="div_count"></component>
                  </FFoldBox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="dataPage==3">
        <div class="leftViewDP">
          <div class="leftTil">
            <FSpanTil title="数据准备" fontSize="16">{{ViewDP.activeView.dataSetName}}</FSpanTil>
            <div class="divSvg" v-if="type !== '修改'">
              <FSvg title="刷新" color="#666" IconSize="22" @click.native="getViewDPDialog(0)"></FSvg>
            </div>
          </div>
          <div class="leftList">
            <div class="list_til noSelect">
              <div class="divSvg">
                <FSvg title="字段" color="#fff" hoverColor="#fff" IconSize="22"></FSvg>
              </div>
              <span class="divSpan">字段</span>
            </div>
            <div class="listUl_count" v-loading="ViewDP.load">
              <ul class="listUl" v-if="ViewDP.list.length">
                <li v-for="item in ViewDP.list" draggable @dragstart="getDragStart(item,$event)" @dragend="dropWDS={type:'',name:'',init:'',startType:-1}" :class="{glClass:item.wd||item.dl}">
                  <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
                  <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
                  <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
                  <span class="name_fie">{{item.field}}</span>
                  <span class="WDMark" v-if="item.wd&&!item.dl">维</span>
                  <span class="WDMark" v-if="item.dl&&!item.wd">度</span>
                  <span class="WDMark" v-if="item.dl&&item.wd">共</span>
                </li>
              </ul>
              <div class="comNoData" v-else><span>暂无数据</span></div>
            </div>
          </div>

        </div>
        <div class="cenViewDP2" id="cenViewDP">
          <div class="tpCon">
            <div class="tpCon_WL">
              <div class="tpConWD" id="ViewDP_wd" @dragover="getDragOver($event)" @drop="getDrag(0,$event)">
                <p>行：</p>
                <div class="div_for" v-for="(item,index) in setChart.wdList" @click="getWDDialog(0,item)" draggable @dragstart="getDivDrag(0,0,index,$event)" :id="'view_wdDiv_'+index" @dragend="getDivDrag(0,1,index,$event)">
                  <span v-if="!item.config.alias">{{item.name}}</span>
                  <span v-if="item.config.alias">{{item.config.alias}}</span>
                  <span class="order_div" v-if="item.config.calc!=='默认'">({{item.config.calc}})</span>
                  <span class="order_div" v-if="item.config.order!=='默认'">({{item.config.order}})</span>
                </div>
              </div>
              <div class="tpConDL" id="ViewDP_dl" @dragover="getDragOver($event)" @drop="getDrag(1,$event)">
                <p>列：</p>
                <div class="div_for" v-for="(item,index) in setChart.dlList" @click="getDLDialog(0,item)" draggable @dragstart="getDivDrag(1,0,index,$event)" :id="'view_dlDiv_'+index" @dragend="getDivDrag(1,1,index,$event)">
                  <span v-if="!item.config.alias">{{item.name}}</span>
                  <span v-if="item.config.alias">{{item.config.alias}}</span>
                  <span class="order_div" v-if="item.config.calc!=='默认'">({{item.config.calc}})</span>
                  <span class="order_div" v-if="item.config.order!=='默认'">({{item.config.order}})</span>
                  <span class="order_div" v-if="item.params.stack">
                    {{'('+item.params.stack+')'}}</span>
                  <span class="order_div" v-if="nowChart.name==='双轴图'">
                    {{item.params.lTAxis===1?'(次)':(item.params.lTAxis===0?'(主)':'')}}</span>
                </div>
              </div>
            </div>
            <div class="tpConSX" id="ViewDP_sx" @dragover="getDragOver($event)" @drop="getDrag(2,$event)">
              <p>筛选：</p>
              <div v-for="(item,index) in setChart.sxList" @click="getSXDialog(0,item)" draggable @dragstart="getDivDrag(2,0,index,$event)" :id="'view_sxDiv_'+index" @dragend="getDivDrag(2,1,index,$event)">
                <span>{{item.name}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="bmCharts" v-loading="state.viewDP.load" id="bmCharts"> -->
          <div class="bmCharts2" id="bmCharts">
            <div class="switchDiv">
              <el-switch v-model="statistics" active-text="统计" inactive-text="">
              </el-switch>
              <el-switch style="display: block" v-model="turn" active-color="#13B5B1" inactive-color="#8CC5FF" active-text="行列转换" inactive-text="">
              </el-switch>
            </div>
            <table v-if="!turn" id="tables1">
              <tr>
                <td>{{listWD}}</td>
                <td v-for="(item,index) in excelList" :key="index">{{item[listWD]}}</td>
                <td v-if="statistics">统计</td>
              </tr>
              <tr v-for="(item,index1) in myList" :key="index1">
                <td>{{item}}</td>
                <td v-for="(item1,index) in excelList" :key="index">{{item1[item]}}</td>
                <td v-if="statistics">{{typeof dlAdd[index1] == 'number'?dlAdd[index1]:"NaN"}}</td>
              </tr>
              <tr v-if="statistics">
                <td>统计</td>
                <td v-for="(item,index) in arrst1" :key="index">{{typeof item == 'number'?item:"NaN"}}</td>
                <td>{{sum}}</td>
              </tr>
            </table>

            <table v-if="turn" id="tables2">
              <tr>
                <td>{{listWD}}</td>
                <td v-for="(item2,index1) in myList" :key="index1">{{item2}}</td>
                <td v-if="statistics">统计</td>
              </tr>
              <tr v-for="(item,index) in excelList" :key="index">
                <td>{{item[listWD]}}</td>
                <td v-for="(item2,index1) in myList" :key="index1">{{item[item2]}}</td>
                <td v-if="statistics">{{typeof arrst1[index] == 'number'?arrst1[index]:"NaN"}}</td>
              </tr>
              <tr v-if="statistics">
                <td>统计</td>
                <td v-for="(item,index1) in myList" :key="index1">{{typeof dlAdd[index1] == 'number'?dlAdd[index1]:"NaN"}}</td>
                <td>{{sum}}</td>
              </tr>
            </table>

          </div>
          <div class="bmPrompt">
            <div class="save_div">
              <FBtn title="取消" type="2" @click="noSave"></FBtn>
              <FBtn title="导出" type="1" @click="daochu()" :disabled="this.state.viewDP.noData"></FBtn>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--切换类型-->
    <FDialog class="createViewDP_dialog" :dialog="ViewDPDialog.show" title="数据准备切换" @close="getViewDPDialog(1)" moveWidth="570px">
      <div class="viewSet_dialog_count">
        <div class="div_radio">
          <el-radio-group v-model="ViewDPDialog.id">
            <el-radio v-for="item in ViewDPDialog.list" :label="item.id">
              {{item.dataSetName}}
            </el-radio>
          </el-radio-group>
        </div>
        <div class="div_btn">
          <FBtn type="1" @click="getViewDPDialogReset">重置</FBtn>
          <FBtn type="3" @click="getViewDPDialog(2)" :disabled="ViewDPDialog.id===ViewDP.id">确定</FBtn>
        </div>
      </div>
    </FDialog>
    <!--添加下钻目录-->
    <FDialog class="createViewDP_dialog" :dialog="RefineDPDialog.show" title="添加下钻目录" @close="getRefineDPDialog(1)" moveWidth="760px">
      <div class="viewSet_dialog_count">
        <div class="div_radio">
          <div class="tit">联机分析字段名称：<input type="text" maxlength="15" v-model="xzTableName"></div>
        </div>
        <div class="div_describe">
          <div class="left">
            <div class="top">字段</div>
            <ul>
              <li v-for="item in ViewDP.list" draggable @dragstart="getDragStart(item,$event)" @dragend="dropWDS={type:'',name:'',init:'',startType:-1}">
                <FSvg title="字符" v-if="item.type===0" color="#13B5B1" IconSize="20"></FSvg>
                <FSvg title="日期" v-if="item.type===1" color="#13B5B1" IconSize="18"></FSvg>
                <FSvg title="数字" v-if="item.type===2" color="#13B5B1" IconSize="20"></FSvg>
                <span class="name_fie">{{item.field}}</span>
              </li>
            </ul>
          </div>
          <div class="right" id="ViewDP_xz" @dragover="getDragOver($event)" @drop="getDrag(3,$event)">
            <div class="div_for" v-for="(item,index) in setChart.xzList" draggable @dragstart="getDivDrag(3,0,index,$event)" :id="'view_xzDiv_'+index" @dragend="getDivDrag(3,1,index,$event)">
              <div class="xuhao">{{index+1}}</div>
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="div_btn">
          <FBtn type="1" @click="saveCatalogue()">保存</FBtn>
          <FBtn type="3" @click="getRefineDPDialog(1)">取消</FBtn>
        </div>
      </div>
    </FDialog>
    <!--维度配置-->
    <FDialog class="ViewDP_wd_dialog" :dialog="dpWD.show" :title="'维度 -'+' '+dpWD.title" @close="getWDDialog(1)" moveWidth="630px">
      <div class="dialog_count">
        <div class="type_radio" v-if="charts.wdComponent">
          <span :class="{addSpan:dpWD.tilType===0}" @click="getDiologTil(0,0)">数据配置</span>
          <span :class="{addSpan:dpWD.tilType===1}" @click="getDiologTil(0,1)">图表配置</span>
        </div>
        <div v-show="dpWD.tilType===0">
          <div class="count_div">
            <div class="div_label noMar_label">
              <span>排序方式</span>
              <el-radio-group v-model="dpWD.config.order">
                <el-radio :label="item" v-for="item in dpWD.configInit.order">{{item}}</el-radio>
              </el-radio-group>
            </div>
            <div class="div_label noMar_label" v-if="dpWD.type==='1'">
              <span>统计分析</span>
              <el-radio-group v-model="dpWD.config.calc">
                <el-radio :label="item" v-for="item in dpWD.configInit.calcDate">{{item}}</el-radio>
              </el-radio-group>
            </div>
            <div class="div_label noMar_label">
              <span>统计分析</span>
              <el-radio-group v-model="dpWD.config.calc" v-if="dpWD.type==='2'">
                <el-radio :label="item" v-for="item in dpWD.configInit.calcNum">
                  {{item}}
                </el-radio>
              </el-radio-group>
            </div>
            <div class="div_label">
              <span>设置别名</span>
              <el-input v-model="dpWD.config.alias" placeholder="别名"></el-input>
            </div>
          </div>
          <div class="div_btn">
            <FBtn type="1" @click="getWDReset">重置</FBtn>
            <FBtn type="3" @click="getWDDialog(2)">确定
            </FBtn>
          </div>
        </div>
        <div v-if="dpWD.tilType===1">
          <component :is="charts.wdComponent" type="view"></component>
        </div>
      </div>
    </FDialog>
    <!--度量配置-->
    <FDialog class="ViewDP_dl_dialog" :dialog="dpDL.show" :title="'度量 -'+' '+dpDL.title" @close="getDLDialog(1)" moveWidth="630px">
      <div class="dialog_count">
        <div class="type_radio" v-if="charts.dlComponent">
          <span :class="{addSpan:dpDL.tilType===0}" @click="getDiologTil(1,0)">数据配置</span>
          <span :class="{addSpan:dpDL.tilType===1}" @click="getDiologTil(1,1)">图表配置</span>
        </div>
        <div v-show="dpDL.tilType===0">
          <div class="count_div">
            <div class="noMar_label div_label">
              <span>排序方式</span>
              <el-radio-group v-model="dpDL.config.order">
                <el-radio :label="item" v-for="item in dpDL.configInit.order">{{item}}</el-radio>
              </el-radio-group>
            </div>
            <div class="div_label noMar_label" v-if="dpDL.type==='1'">
              <span>统计分析</span>
              <el-radio-group v-model="dpDL.config.calc">
                <el-radio :label="item" v-for="item in dpDL.configInit.calcDate">{{item}}</el-radio>
              </el-radio-group>
            </div>
            <div class="div_label noMar_label">
              <span>统计分析</span>
              <el-radio-group v-model="dpDL.config.calc">
                <el-radio :label="item" v-for="item in dpDL.configInit.calcNum" v-if="dpDL.type==='2'">
                  {{item}}
                </el-radio>
                <el-radio :label="item" v-for="item in dpDL.configInit.calcStr" v-if="dpDL.type==='0'">
                  {{item}}
                </el-radio>
              </el-radio-group>
            </div>
            <div class="div_label">
              <span>设置别名</span>
              <el-input v-model="dpDL.config.alias" placeholder="别名"></el-input>
            </div>
          </div>
          <div class="div_btn">
            <FBtn type="1" @click="getDLReset">重置</FBtn>
            <FBtn type="3" @click="getDLDialog(2)">确定</FBtn>
          </div>
        </div>
        <div v-if="dpDL.tilType===1">
          <component :is="charts.dlComponent" type="view" :index="dpDL.index"></component>
        </div>
      </div>
    </FDialog>
    <!--筛选配置-->
    <FDialog class="ViewDP_sx_dialog" :dialog="dpSX.show" :title="'筛选 -'+' '+dpSX.title" @close="getSXDialog(1)" moveWidth="730px">
      <div class="dialog_count">
        <div class="count_div">
          <!--字符串-->
          <div class="noMar_label div_label" v-if="dpSX.type==='0'&&dpSX.config.convStrFilList.length">
            <span>常规筛选</span>
            <div>
              <el-checkbox :indeterminate="dpSX.configInit.convStrFil.indCheck" v-model="dpSX.configInit.convStrFil.checkAll" @change="getDPSXconvStrCheckAll(0)">全选
              </el-checkbox>
            </div>
            <el-checkbox-group v-model="dpSX.config.convStrCheck" @change="getDPSXconvStrCheckAll(1)">
              <el-checkbox v-for="item in dpSX.config.convStrFilList" :label="item" :key="item">{{item}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div v-if="dpSX.type==='0'" class="tjFil div_label noMar_label">
            <span>条件筛选</span>
            <div class="for_tjFil">
              <FSvg title="加" IconSize="20" @click.native="getDPSXDitStr('add')" v-if="!dpSX.config.ditStr.length" class="oneAdd"></FSvg>
              <div v-for="(item,index) in dpSX.config.ditStr" class="tjFilCoDiv">
                <span>{{dpSX.title}}</span>
                <el-select v-model="item.type" placeholder="请选择">
                  <el-option v-for="it2 in dpSX.configInit.ditStrFil" :label="it2" :value="it2">
                  </el-option>
                </el-select>
                <el-input v-model="item.value" placeholder="请输入内容"></el-input>
                <FSvg title="删除" IconSize="20" @click.native="getDPSXDitStr('del',index)"></FSvg>
                <FSvg title="加" IconSize="20" @click.native="getDPSXDitStr('add')" v-if="(index+1)===dpSX.config.ditStr.length"></FSvg>
              </div>
            </div>
          </div>
          <!--时间-->
          <div v-if="dpSX.type==='1'" class="div_label">
            <span @click="chooseTime1()">时间筛选</span@>
              <el-date-picker v-model="dpSX.config.timDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-if="chooseTime==1">
              </el-date-picker>
          </div>
          <div v-if="dpSX.type==='1'" class="div_label noMar_label">
            <span @click="chooseTime2()">离散时间</span>
            <el-radio-group v-model="dpSX.config.disDateType" @change="getSXDisDateType" v-if="chooseTime==2">
              <el-radio :label="item.type" v-for="item in dpSX.config.disDateFil">{{item.type}}</el-radio>
            </el-radio-group>
            <div v-if="dpSX.configInit.disDateLs.list.length&&chooseTime==2">
              <el-checkbox :indeterminate="dpSX.configInit.disDateLs.indCheck" v-model="dpSX.configInit.disDateLs.checkAll" @change="getDPSXconvDateCheckAll(0)">全选
              </el-checkbox>
              <el-checkbox-group v-model="dpSX.config.disDateCheck" @change="getDPSXconvDateCheckAll(1)">
                <el-checkbox v-for="item in dpSX.configInit.disDateLs.list" :label="item" :key="item">{{item}}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <!--You may have an infinite update loop in watcher with expression "dpSX"-->

          <!--数值-->
          <div v-if="dpSX.type==='2'&&dpSX.config.ranNumSTEN.start!==dpSX.config.ranNumSTEN.end" class="div_label">
            <span>范围筛选</span>
            <div class="input_num_fil">
              <el-input v-model="dpSX.config.ranNum[0]" readonly></el-input>
              <el-input v-model="dpSX.config.ranNum[1]" readonly></el-input>
            </div>
            <el-slider v-model="dpSX.config.ranNum" :min="dpSX.config.ranNumSTEN.start" :show-tooltip="false" :max="dpSX.config.ranNumSTEN.end" range></el-slider>
            <div class="span_num_label">
              <span class="span_fir">{{dpSX.config.ranNumSTEN.start}}</span>
              <span class="span_las">{{dpSX.config.ranNumSTEN.end}}</span>
            </div>
          </div>
          <div v-if="dpSX.type==='2'" class="tjFil div_label ">
            <span>条件筛选</span>
            <div class="for_tjFil">
              <FSvg title="加" IconSize="20" @click.native="getDPSXDitNum('add')" v-if="!dpSX.config.ditNum.length" class="oneAdd"></FSvg>
              <div v-for="(item,index) in dpSX.config.ditNum" class="tjFilCoDiv">
                <span>{{dpSX.title}}</span>
                <el-select v-model="item.type" placeholder="请选择">
                  <el-option v-for="it2 in dpSX.configInit.ditNumFil" :label="it2" :value="it2">
                  </el-option>
                </el-select>
                <el-input v-if="item.type!=='区间'" v-model="item.value" placeholder="请输入内容"></el-input>
                <el-input v-if="item.type==='区间'" v-model="item.q1" placeholder="值1" class="qj_item"></el-input>
                <el-input v-if="item.type==='区间'" v-model="item.q2" placeholder="值2" class="qj_item"></el-input>
                <FSvg title="删除" IconSize="20" @click.native="getDPSXDitNum('del',index)"></FSvg>
                <FSvg title="加" IconSize="20" @click.native="getDPSXDitNum('add')" v-if="(index+1)===dpSX.config.ditNum.length"></FSvg>
              </div>
            </div>
          </div>
          <div class="div_label">
            <span>空值筛选</span>
            <el-radio-group v-model="dpSX.config.nullVal">
              <el-radio :label="item.id" v-for="item in dpSX.configInit.nullFil">{{item.name}}</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="div_btn">
        <FBtn type="1" @click="getSXReset">重置</FBtn>
        <FBtn type="3" @click="getSXDialog(2)">确定
        </FBtn>
      </div>
    </FDialog>
  </div>
</template>
<script>
/**
 @author xiaoye
 @date 2020/4/22 3:08 下午
 */
import {
  GetDataSetList,
  GetConnByDataSource
} from '@/assets/axios/dataUpload/viewSet'
import $ from 'jquery'
import {
  GetColumnByDataSetID,
  GetValuesByStringField,
  GetValuesByNumberField,
  GetValuesByDateField,
  GetEchartsData,
  UploadPreviewPictureAsync,
  GetDataViewNameVerify,
  SaveCharts,
  GetDataViewByID,
  UploadPreviewPictureAsyncByBase64,
  SubDrilling,
  GetDrillingInfo
} from '@/assets/axios/dataUpload/createViewDP'
import modules from '../../charts/script/modules'
import comChart from '../../charts/comConfig/comChart'
import setConfigAll from '@/assets/js/config'
import viewChart from './viewChart.vue'
import vLeftSource from '@/components/LeftSource/LeftSource.vue'
import option from '../../createScreen/script/option'
export default {
  name: 'createViewDP',
  components: {
    comChart,
    viewChart,
    vLeftSource,
  },
  props: {},
  data() {
    return {
      chooseTime: 1,
      timer: "",
      statistics: false,
      turn: true,
      dlAdd: [],
      arrst1: [],
      newAll: [],
      newArr: [],
      sum: "",
      myList: [],
      listWD: "",
      listZB: "",
      excelList: [],
      pickerFormat: "",
      pickerType: "",
      value1: '',
      options1: "",
      options2: "",
      optionsList1: ["年度观测", "月度观测", "日度观测"],
      optionsList2: ["无", "增长率", "发展速度"],
      radio: "1",
      dataPage: 1,
      ifDrill: 0,
      mbxList: [],
      softContent1: "",
      clicktimes: "",
      softContent: [],
      //当前联机分析字段
      // drillingName: "",
      //钻取最大顺序
      SoftLevel: "",
      active: -1,
      //右侧配置伸缩状态
      arrxzList: [],
      //联机分析字段名称
      xzTableName: '',
      //下钻目录
      xzList: [],
      //操作 0 无操作 1 以操作
      viewDPOpera: 0,
      //全局刷新
      allLoad: false,
      //当前页面的状态
      type: '创建',
      //默认的 vuex viewDP
      vuexViewDP: {},
      //接口返回的详情
      oldDetailsJSON: {},
      //提示
      cenBmPrompt: '',
      //当前页面基础配置
      ViewDP: {
        //数据接入
        sourceId: '',
        //数据准备
        id: '',
        activeView: {},
        list: [],
        load: true,
        menuName: []
      },
      //数据准备弹框
      ViewDPDialog: {
        id: '',
        show: false,
        list: []
      },
      RefineDPDialog: {
        id: '',
        show: false,
        list: []
      },
      //维度弹框
      dpWD: {
        show: false,
        title: '',
        oldItem: '',
        tilType: 0,
        //0 字符 1 时间 2 数值
        type: '0',
        //当前的下标
        index: 0,
        //配置数据
        configInit: {
          order: [
            '默认',
            '升序',
            '降序'
          ],
          //数字
          calcNum: [
            '默认',
            '总数',
            '平均值',
            '最大值',
            '最小值',
            '计数',
            '去重计数',
          ],
          //字符串
          calcStr: [
            '默认',
            '计数',
          ],
          //时间
          calcDate: [
            '默认',
            '年',
            '月',
            '日',
            '时',
            '分',
            '秒',
          ],
        },
        //配置
        config: {
          order: '默认',
          alias: '',
          calc: '默认'
        },
      },
      //维度弹框
      dpDL: {
        show: false,
        title: '',
        oldItem: '',
        tilType: 0,
        //0 字符 1 时间 2 数值
        type: '0',
        //当前的下标
        index: 0,
        //配置数据
        configInit: {
          order: [
            '默认',
            '升序',
            '降序'
          ],
          //数字
          calcNum: [
            '默认',
            '总数',
            '平均值',
            '最大值',
            '最小值',
            '计数',
            '去重计数',
          ],
          //字符串
          calcStr: [
            '默认',
            '计数',
          ],
          //时间
          calcDate: [
            '默认',
            '年',
            '月',
            '日',
            '时',
            '分',
            '秒',
          ],
        },
        //配置
        config: {
          order: '默认',
          alias: '',
          calc: '默认'
        },
      },
      //筛选弹框
      dpSX: {
        show: false,
        title: '',
        //0 字符 1 时间 2 数值
        type: '0',
        disabled: false,
        index: '',
        //配置数据
        configInit: {
          //空值筛选
          nullFil: [
            { id: 1, name: '非空值' },
            { id: 0, name: '空值' }
          ],
          //字符串 常规筛选
          convStrFil: {
            checkAll: true,
            indCheck: false
          },
          //字符串 条件筛选
          ditStrFil: [
            '等于',
            '不等于',
            '包含',
            '不包含',
            '开头包含',
            '结尾包含',
          ],
          //数字 条件筛选
          ditNumFil: [
            '区间',
            '等于',
            '不等于',
            '大于',
            '小于',
            '大于等于',
            '小于等于',
          ],
          //时间 离散时间
          disDateLs: {
            checkAll: true,
            indCheck: false,
            list: []
          }
        },
        //配置
        config: {
          //空值
          nullVal: 1,
          /* - - - - - - - 日期 - - - - - -*/
          //是否进行过 日期 接口逻辑
          datebool: false,
          //时间筛选
          timDate: [],
          //离散时间 类型
          disDateType: '默认',
          //离散时间 选中的数组
          disDateCheck: [],
          //离散时间 总的数组
          disDateFil: [{
            type: '默认',
            values: []
          }],
          /* - - - - - - - 字符 - - - - - -*/
          //是否进行过 字符串 接口逻辑
          strbool: false,
          //常规筛选 总的数组
          convStrFilList: [],
          //常规筛选 选中的数组
          convStrCheck: [],
          //条件筛选
          ditStr: [],
          /* - - - - - - - 数字 - - - - - -*/
          //是否进行过 数字 接口逻辑
          numbool: false,
          //范围筛选
          ranNum: [0, 100],
          //范围筛选 起始/终点
          ranNumSTEN: {
            start: 0,
            end: 100
          },
          //条件筛选
          ditNum: [],
        },
      },
      //删除维度 度量 筛选数据
      removeDrop: {
        start: { tX: 0, tY: 0, bX: 0, bY: 0 },
        over: { left: 0, top: 0, },
        type: 0
      },
      //拖动数据传递
      dropWDS: {
        name: '',
        type: '',
        init: '',
        startType: -1
      },
      // 图表图片服务器地址
      chartsimgUrl: setConfigAll.chartsRequestUrl,
      //图表
      charts: {
        type: '',
        name: '',
        component: [],
        wdParams: {},
        dlParams: {},
        dlComponent: null,
        wdComponent: null,
        showComPonent: false,
        //保存的图片地址
        imgHref: '',
      },

      //右侧配置项
      rigConfig: {
        //类型
        type: 0,
        //图表数组
        list: [],
        //多维分析名称
        reportName: '',
        collapseModal: [
          '公共配置',
        ],
      },
    }
  },
  methods: {
    chooseTime1() {
      this.chooseTime = 1;
      this.dpSX.config.disDateType = "";
      this.dpSX.config.disDateCheck = [];
    },
    chooseTime2() {
      this.chooseTime = 2
      this.dpSX.config.timDate = []
    },
    daochu() {
      let tdLs = Array.from($('table td')).map(v => { return v.textContent })     // 获取表体数据
      let combine = tdLs   // 表头表体数据聚合
      //- 表格数据转csv格式
      let csv = ''
      if (this.statistics && this.turn) {
        var colWidth = this.setChart.wdList.length + this.setChart.dlList.length + 1
      } else if (!this.statistics && this.turn) {
        var colWidth = this.setChart.wdList.length + this.setChart.dlList.length
      }
      if (this.statistics && !this.turn) {
        var colWidth = this.excelList.length + 2
      } else if (!this.statistics && !this.turn) {
        var colWidth = this.excelList.length + 1
      }
      let column = []         // 列循环数据缓存
      combine.map((v, i) => {
        column.push(v.trim())
        if ((i + 1) % colWidth === 0) {
          csv += column.join(",") + '\n'
          column = []
        }
      })

      //- 表格导出
      let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(csv);
      let link = document.createElement("a");
      let ts = new Date()
      link.href = uri;
      link.download = ts.getFullYear() + '/' + (ts.getMonth() + 1) + '/' + ts.getDay() + " 数据透视.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    radioChange() {
      if (this.radio == "1") {
        this.optionsList1 = ["年度观测", "月度观测", "日度观测"];
        this.optionsList2 = ["无", "增长率", "发展速度"];
        this.value1 = "";
        this.options1 = "";
        this.options2 = "";
      } else if (this.radio == "2") {
        this.optionsList1 = ["年度观测", "月度观测"];
        this.optionsList2 = ["无", "增长率", "发展速度"];
        this.value1 = "";
        this.options1 = "";
        this.options2 = "";
        if (!this.options1) {
          this.pickerType = ""
        }
      }
    },
    lookCycle() {

      this.value1 = ""
      if (this.options1 == "月度观测") {
        this.pickerType = 'date';
        this.pickerFormat = 'dd'
      } else if (this.options1 == "年度观测") {
        this.pickerType = 'month'
        this.pickerFormat = 'MM'
      }
      if (this.options1 && this.options2 && this.setChart.wdList.length != 0 && this.setChart.dlList != 0) {
        this.getRendCharts()
      }
    },
    lookCycle2() {
      if (this.options1 == "月度观测") {
        this.pickerType = 'date';
        this.pickerFormat = 'dd'
      } else if (this.options1 == "年度观测") {
        this.pickerType = 'month'
        this.pickerFormat = 'MM'
      }
      if (this.options1 && this.options2 && this.setChart.wdList.length != 0 && this.setChart.dlList != 0) {
        this.getRendCharts()
      }
    },
    lookCycle3() {

      if (this.options1 == "月度观测") {
        this.pickerType = 'date';
        this.pickerFormat = 'dd'
      } else if (this.options1 == "年度观测") {
        this.pickerType = 'month'
        this.pickerFormat = 'MM'
      }
      if (this.options1 && this.options2 && this.setChart.wdList.length != 0 && this.setChart.dlList != 0) {
        this.getRendCharts()
      }
    },
    goPZ() {
      this.dataPage = 1;
      this.getCheckWDFie()
      this.getRendCharts()
    },
    goFX() {
      // this.options1 = "年度观测"
      // this.options2 = "无"
      this.dataPage = 2;
      if (this.setChart.wdList.length != 0) {
        if (this.setChart.wdList[0].type != 1) {
          this.setChart.wdList = [];
        }
      }
      for (var i = 0; i < this.setChart.dlList.length; i++) {
        if (this.setChart.dlList[i].type != 2) {
          this.setChart.dlList.splice(i, 1);
        }
      }
      if (this.setChart.dlList.length != 0) {
        if (this.setChart.dlList[0].type != 2) {
          this.historyDL = this.setChart.dlList
        }
      }
      this.getCheckWDFie()
      this.getRendCharts()
    },
    goTS() {
      this.dataPage = 3;
      this.setChart.wdList = [];
      this.setChart.dlList = [];
      this.getCheckWDFie();
      if (this.setChart.wdList.length != 0 && this.setChart.dlList != 0) {
        this.getFilCharts();
      }
      this.newArr = []
    },
    xz() {
      this.softContent1 = localStorage.getItem('softContent1')
      this.mbxList.push(this.softContent1)
      this.getRendCharts();
    },
    sz() {
      this.mbxList.pop();
      if (this.mbxList.length == 0) {
        this.softContent = ''
        this.mbxList = []
      } else {
        this.softContent = this.mbxList[this.mbxList.length - 1]
      }
      window.localStorage.setItem('softContent', this.softContent) //存值
      this.softContent = localStorage.getItem('softContent') //取值
      this.getRendCharts();
    },
    all() {
      window.localStorage.setItem('softContent', "")//存值
      this.mbxList = []
      this.getRendCharts();
    },
    suofang() {
      var rigViewDP = document.getElementById("rigViewDP");
      var cenViewDP = document.getElementById("cenViewDP");
      var bmCharts = document.getElementById("bmCharts");

      if (rigViewDP.style.right == "-344px") {
        cenViewDP.style.width = "960px"
        bmCharts.style.width = "685px"
        rigViewDP.setAttribute("style", "right:10px");
        this.getRendCharts()
        return
      }
      if (rigViewDP.style.right == "10px") {
        cenViewDP.style.width = "1304px"
        bmCharts.style.width = "1025px"
        rigViewDP.setAttribute("style", "right:-344px");
        this.getRendCharts()
        return
      }
    },
    //保存下钻目录
    async saveCatalogue() {
      this.xzList = JSON.parse(JSON.stringify(this.setChart.xzList).replace(/index/g, 'soft'));
      for (let i = 0; i <= this.xzList.length - 1; i++) {
        delete this.xzList[i].type
        this.xzList[i].soft = this.xzList[i].soft + 1;
      }

      if (!this.xzTableName) {
        this.getMsg('请输入联机分析字段名称');
        return;
      }
      if (this.xzList.length == 0) {
        this.getMsg('请拖拽下钻字段');
        return;
      }
      await SubDrilling({
        type: 1,
        dataSourceId: this.ViewDP.sourceId,
        // viewsName: this.ViewDP.activeView.dataSetName,
        dataSetID: this.ViewDP.id,
        drIIlingName: this.xzTableName,
        drillingFields: this.xzList,
      }).then(res => {
        if (res.code === 200) {
          this.getMsg(res.message, 'success');
          this.RefineDPDialog.show = false;
          this.getColumnList()
        }
      }).catch(() => { })
    },
    noSave() {
      this.$router.push('/viewSet')
    },
    //
    resize() {
      if (!this.state.viewDP.chart.comp.show) {
        try {
          let echart = echarts.init(this.state.viewDP.dom);
          echart.resize();
        } catch (e) {

        }
      }
    },
    //获取数据
    async init() {
      let setId = this.getSession('view_setId_xy');
      let chartsId = this.getSession('view_chartsId_xy');
      let sourceId = this.getSession('view_source_xy');
      if (setId && sourceId) {
        this.ViewDP.id = setId;
        this.ViewDP.sourceId = sourceId;
      } else {
        this.$router.push('/viewSet');
        return;
      }
      if (await !this.getTestViewSet(this.ViewDP.sourceId)) {
        this.$router.push('/viewSet');
        return;
      }
      //多维分析
      this.$store.state.dpType = 0;
      await this.$store.dispatch('clearViewDP');
      if (chartsId) {
        this.type = '修改';
      } else {
        this.type = '创建';
      }
      this.vuexViewDP = JSON.parse(JSON.stringify(this.state.viewDP));
      await this.getViewSetList();
      await this.getFieList();
      await this.getChartsAll();
      await this.getColumnList();
      if (this.type === '修改') {
        this.getDetailsChart(chartsId);
      }
    },
    //测试是否可以连接数据接入
    async getTestViewSet(dataSourceID) {
      let bool = false;
      this.allLoad = true;
      await GetConnByDataSource({
        dataSourceID: dataSourceID
      }).then(res => {
        if (res.code === 200) {
          bool = true;
        }
      }).catch(() => {
      });
      setTimeout(() => {
        this.allLoad = false;
      }, 300);
      return bool;
    },

    //*- - - - - - - - 数据准备弹框 - - - - - - - - -

    //数据准备弹框
    getViewDPDialog(type) {
      if (type === 0) {
        this.getViewDPDialogReset();
        this.ViewDPDialog.show = true;
      } else if (type === 1) {
        this.ViewDPDialog.show = false;
      } else if (type === 2) {
        this.$alert('切换数据准备将不会保存您所创建的图表 是否切换数据准备?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          customClass: 'alert_allCom',
        }).then(async () => {
          this.ViewDP.id = this.ViewDPDialog.id;
          await this.getDialogRadioChange();
          await this.getNoVal();
          this.ViewDPDialog.show = false;
          await this.getFieList();
          this.getSoSet(1, this.ViewDP.id);
        }).catch(() => {

        });
      }
    },
    //添加下钻目录弹窗
    getRefineDPDialog(type) {
      if (type === 0) {
        this.getViewDPDialogReset();
        this.RefineDPDialog.show = true;

      } else if (type === 1) {
        this.RefineDPDialog.show = false;

      }
    },
    //获取数据准备
    async getViewSetList() {
      await GetDataSetList({
        pageIndex: 1,
        pageSize: 99999,
        dataSourceID: this.ViewDP.sourceId,
      }).then(async res => {
        if (res.code === 200) {
          this.ViewDPDialog.list = res.data.dataTabel;
          await this.getDialogRadioChange();
        } else {
          this.ViewDPDialog.list = [];
        }
      }).catch(() => {
      });
    },
    //清空页面所有数据
    getNoVal() {
      this.state.viewDP = this.vuexViewDP;
      let dom = document.getElementById('view_chartID');
      let echart = echarts.init(dom);
      echart.clear();
      this.state.viewDP.noData = true;
    },
    //数据准备弹框 切换数据
    getDialogRadioChange() {
      this.ViewDP.activeView = {};
      this.ViewDPDialog.list.map((item) => {
        if (item.id === this.ViewDP.id) {
          this.ViewDP.activeView = item;
        }
      });
    },
    //重置数据准备弹框
    getViewDPDialogReset() {
      this.ViewDPDialog.id = this.ViewDP.id;
      this.getDialogRadioChange();
    },
    //获取字段
    async getFieList() {
      this.ViewDP.load = true;
      await GetColumnByDataSetID({
        dataSetID: this.ViewDP.id
      }).then(res => {
        if (res.code === 200) {
          if (res.data.dataTabel.length) {
            this.ViewDP.list = [];
            res.data.dataTabel.map((item) => {
              this.ViewDP.list.push({
                field: item.field,
                type: item.type,
                wd: false,
                dl: false,
              })
            })
          } else {
            this.ViewDP.list = [];
          }
        } else {
          this.ViewDP.list = [];
        }
      }).catch(() => {
        this.ViewDP.list = [];
      });
      setTimeout(() => {
        this.ViewDP.load = false;
      }, 300)
    },
    //获取下钻目录
    async getColumnList() {
      this.ViewDP.load = true;
      await GetDrillingInfo({
        dataSourceID: this.ViewDP.sourceId,
        // viewsName: this.ViewDP.activeView.dataSetName,
        dataSetID: this.ViewDP.id,
      }).then(res => {
        if (res.code === 200) {
          if (res.data.length) {
            this.ViewDP.ColumnList = [];
            res.data.map((item) => {
              this.ViewDP.ColumnList.push({
                menuField: item.menuField,
                menuName: item.menuName,
                wd: false,
              })
            })
          } else {
            this.ViewDP.ColumnList = [];
          }
        } else {
          this.ViewDP.ColumnList = [];
        }
      }).catch(() => {
        this.ViewDP.ColumnList = [];
      });
      setTimeout(() => {
        this.ViewDP.load = false;
      }, 300)
    },
    //弹框的选择项
    getDiologTil(index, type) {
      if (index === 0) {
        if (type === this.dpWD.tilType) {
          return;
        }
        this.dpWD.tilType = type;
      } else if (index === 1) {
        if (type === this.dpDL.tilType) {
          return;
        }
        this.dpDL.tilType = type;
      }
    },
    //高亮选择的字段
    getCheckWDFie() {
      if (this.ViewDP.list.length != 0) {
        this.ViewDP.list.map((item, index) => {
          this.ViewDP.list[index].wd = false;
          this.ViewDP.list[index].dl = false;
          for (let i of this.setChart.wdList) {
            if (item.field === i.name) {
              this.ViewDP.list[index].wd = true;
              break;
            }
          }
          for (let i of this.setChart.dlList) {
            if (item.field === i.name) {
              this.ViewDP.list[index].dl = true;
              break;
            }
          }
        });
      }

      if (this.ViewDP.ColumnList.length != 0) {
        this.ViewDP.ColumnList.map((item, index) => {
          this.ViewDP.ColumnList[index].wd = false;
          for (let i of this.setChart.wdList) {
            if (item.menuName === i.name) {
              this.ViewDP.ColumnList[index].wd = true;
              break;
            }
          }
        });
      }
    },

    //*- - - - - - - - 拖动 - - - - - - - - - */

    //生成拖动数据
    async getDrag(index) {
      //已操作
      this.viewDPOpera = 1;
      if (this.dropWDS.startType === index) {
        return;
      }
      if (index === 0) {
        if (this.dropWDS.type != undefined) {
          if (this.dataPage == 2 && (this.dropWDS.type == 2 || this.dropWDS.type == 0)) {
            return this.getMsg('当前维度只允许拖拽时间格式的字段', 'info');
          }
          let type = this.dropWDS.type.toString();
          let name = this.dropWDS.name.toString();
          if (!type || !name) {
            return;
          }
          let count = 0;
          this.setChart.wdList.map(item => {
            if (item.name === name) {
              count = 1;
            }
          });
          if (count !== 0) {
            return this.getMsg('当前维度已存在字段【 ' + name + ' 】', 'info');
          }
          if (this.setChart.wdList.length == 1) {
            return this.getMsg('当前维度最多只能存在1个维度', 'info');
          }
          this.setChart.wdList.push({
            type: type,
            name: name,
            index: this.setChart.wdList.length,
            config: this.state.viewDP.comWDConfig,
            params: JSON.parse(JSON.stringify(this.charts.wdParams))
          });
        }
        else if (!this.dropWDS.type) {
          let name = this.dropWDS.name.toString();
          let count = 0;
          this.setChart.wdList.map(item => {
            if (item.name === name) {
              count = 1;
            }
          });
          if (count !== 0) {
            return this.getMsg('当前维度已存在【 ' + name + ' 】目录', 'info');
          }
          this.setChart.wdList.push({
            name: name,
            index: this.setChart.wdList.length,
            config: this.state.viewDP.comWDConfig,
            params: JSON.parse(JSON.stringify(this.charts.wdParams))
          });
        }
      } else if (index === 1) {
        if (this.dataPage == 2 && (this.dropWDS.type == 1 || this.dropWDS.type == 0)) {
          return this.getMsg('当前度量只允许拖拽数值格式的字段', 'info');
        }
        let type = this.dropWDS.type.toString();
        let name = this.dropWDS.name.toString();
        if (!type || !name) {
          return;
        }
        let count = 0;
        this.setChart.dlList.map(item => {
          if (item.name === name) {
            count = 1;
          }
        });
        if (count !== 0) {
          return this.getMsg('当前度量已存在字段【' + name + '】', 'info');
        }
        if (this.setChart.dlList.length == 10) {
          return this.getMsg('当前度量最多只能存在10个维度', 'info');
        }
        this.setChart.dlList.push({
          type: type,
          name: name,
          index: this.setChart.dlList.length,
          config: this.state.viewDP.comDLConfig,
          params: JSON.parse(JSON.stringify(this.charts.dlParams)),
        });
      } else if (index === 2) {
        let type = this.dropWDS.type.toString();
        let name = this.dropWDS.name.toString();
        if (!type || !name) {
          return;
        }
        let count = 0;
        this.setChart.sxList.map(item => {
          if (item.name === name) {
            count = 1;
          }
        });
        if (count !== 0) {
          return this.getMsg('当前筛选已存在字段【' + name + '】', 'info');
        }
        this.setChart.sxList.push({
          type: type,
          name: name,
          index: this.setChart.sxList.length,
          config: this.state.viewDP.comSXConfig,
        });
      }
      else if (index === 3) {
        let type = this.dropWDS.type.toString();
        let name = this.dropWDS.name.toString();
        if (!type || !name) {
          return;
        }
        let count = 0;
        this.setChart.xzList.map(item => {
          if (item.name === name) {
            count = 1;
          }
        });
        if (count !== 0) {
          return this.getMsg('当前下钻已存在字段【' + name + '】', 'info');
        }
        this.setChart.xzList.push({
          type: type,
          name: name,
          index: this.setChart.xzList.length,
          config: this.state.viewDP.comXZConfig,
        });
      }
      if (this.dropWDS.init === 0) {
        await this.getRendCharts();
      }
    },
    //拖动之前
    getDragStart(item) {
      this.dropWDS = {
        type: item.type,
        name: item.field,
        startType: -1,
        init: 0,
      }
    },
    getDragStartML(item) {
      this.dropWDS = {
        name: item.menuName,
        startType: -1,
        init: 0,
      }
    },
    //拖动之后
    getDragOver(ev) {
      window.localStorage.setItem('softContent', "")//存值
      if (this.dropWDS.type != undefined) {
        let type = this.dropWDS.type.toString();
        let name = this.dropWDS.name.toString();
        if (type && name) {
          this.getNoEvent(ev);
        }
      } else if (!this.dropWDS.type) {
        if (this.dropWDS.name) {
          this.getNoEvent(ev);
        }
      }

    },
    //拖动之后 整体拖动
    getDragAllOver(ev) {
      let remType = this.removeDrop.type.toString();
      if (remType) {
        let bool = true;
        if (this.removeDrop.start.bY > ev.pageY && ev.pageY > this.removeDrop.start.tY) {
          if (this.removeDrop.start.bX > ev.pageX && ev.pageX > this.removeDrop.start.tX) {
            bool = false;
          }
        }
        if (bool) {
          this.getNoEvent(ev);
        }
      }
    },
    //拖动之前
    async getDivDrag(index, type, i, ev) {
      let dqDivName = '';
      let divName = '';
      let WDSType = '';
      let WDSName = '';
      let startType = -1;
      if (index === 0) {
        dqDivName = "view_wdDiv_" + i;
        divName = "ViewDP_wd";
        WDSType = this.setChart.wdList[i].type;
        WDSName = this.setChart.wdList[i].name;
        startType = 0;
      } else if (index === 1) {
        dqDivName = "view_dlDiv_" + i;
        divName = "ViewDP_dl";
        WDSType = this.setChart.dlList[i].type;
        WDSName = this.setChart.dlList[i].name;
        startType = 1;
      } else if (index === 2) {
        dqDivName = "view_sxDiv_" + i;
        divName = "ViewDP_sx";
        WDSType = this.setChart.sxList[i].type;
        WDSName = this.setChart.sxList[i].name;
        startType = 2;
      } else if (index === 3) {
        dqDivName = "view_xzDiv_" + i;
        divName = "ViewDP_xz";
        WDSType = this.setChart.xzList[i].type;
        WDSName = this.setChart.xzList[i].name;
        startType = 3;
      }
      if (WDSType && WDSName) {
        this.dropWDS.type = WDSType;
        this.dropWDS.name = WDSName;
        this.dropWDS.startType = startType;
        this.dropWDS.init = 1;
      }
      if (type === 0) {
        this.removeDrop.type = '拖动';
        let dqDiv = document.getElementById(dqDivName);
        let div = document.getElementById(divName);
        this.removeDrop.start = { tX: 0, tY: 0, bX: 0, bY: 0 };
        let top = ev.pageY - ev.offsetY - dqDiv.offsetTop;
        let left = ev.pageX - ev.offsetX - dqDiv.offsetLeft;
        let width = div.offsetWidth;
        let height = div.offsetHeight;
        this.removeDrop.start.tX = left;
        this.removeDrop.start.tY = top;
        this.removeDrop.start.bX = left + width;
        this.removeDrop.start.bY = top + height;
      } else if (type === 1) {
        let bool = true;
        this.removeDrop.type = '';
        if (this.removeDrop.start.bY > ev.pageY && ev.pageY > this.removeDrop.start.tY) {
          if (this.removeDrop.start.bX > ev.pageX && ev.pageX > this.removeDrop.start.tX) {
            bool = false;
          }
        }
        if (bool) {
          if (index === 0) {
            this.setChart.wdList.splice(i, 1);
          } else if (index === 1) {
            this.setChart.dlList.splice(i, 1);
          } else if (index === 2) {
            this.setChart.sxList.splice(i, 1);
          } else if (index === 3) {
            this.setChart.xzList.splice(i, 1);
          }
          this.dropWDS.type = '';
          this.dropWDS.name = '';
          this.dropWDS.startType = -1;
          this.dropWDS.init = '';
          await this.getRendCharts();
        }
      }
    },

    //*- - - - - - - - 维度配置 - - - - - - - - -

    async getWDDialog(type, item) {
      if (type === 0) {
        this.dpWD.title = item.name;
        this.dpWD.type = item.type;
        this.dpWD.index = 0;
        this.setChart.wdList.map((node, nodeI) => {
          if (item.name === node.name) {
            this.dpWD.index = nodeI;
          }
        });
        this.dpWD.oldItem = JSON.stringify(item);
        this.dpWD.config = JSON.parse(JSON.stringify(item.config));
        this.dpWD.tilType = 0;
        this.dpWD.show = true;
      } else if (type === 1) {
        this.dpWD.show = false;
      } else if (type === 2) {
        let count = 0;
        if (this.dpWD.config.alias) {
          this.setChart.wdList.map((node, nodeI) => {
            if (node.config.alias === this.dpWD.config.alias && this.dpWD.index !== nodeI) {
              count = 1;
            }
          });
        }
        if (count !== 0) {
          this.getMsg('别名【' + this.dpWD.config.alias + '】已存在！', 'info');
          return;
        }
        this.setChart.wdList[this.dpWD.index].config = JSON.parse(JSON.stringify(this.dpWD.config));
        this.dpWD.show = false;
        await this.getRendCharts();
      }
    },
    //维度 重置
    getWDReset() {
      let data = JSON.parse(this.dpWD.oldItem);
      this.dpWD.config = data.config;
    },

    //*- - - - - - - - 度量配置 - - - - - - - - -

    async getDLDialog(type, item) {
      if (type === 0) {
        this.dpDL.title = item.name;
        this.dpDL.type = item.type;
        this.dpDL.index = 0;
        this.setChart.dlList.map((node, nodeI) => {
          if (item.name === node.name) {
            this.dpDL.index = nodeI;
          }
        });
        this.dpDL.oldItem = JSON.stringify(item);
        this.dpDL.config = JSON.parse(JSON.stringify(item.config));
        this.dpDL.tilType = 0;
        this.dpDL.show = true;
      } else if (type === 1) {
        this.dpDL.show = false;
      } else if (type === 2) {
        let count = 0;
        if (this.dpDL.config.alias) {
          this.setChart.dlList.map((node, nodeI) => {
            if (node.config.alias === this.dpDL.config.alias && this.dpDL.index !== nodeI) {
              count = 1;
            }
          });
        }
        if (count !== 0) {
          this.getMsg('别名【' + this.dpDL.config.alias + '】已存在！', 'info');
          return;
        }
        this.setChart.dlList[this.dpDL.index].config = JSON.parse(JSON.stringify(this.dpDL.config));
        this.dpDL.show = false;
        await this.getRendCharts();
      }
    },
    //度量 重置
    getDLReset() {
      let data = JSON.parse(this.dpDL.oldItem);
      this.dpDL.config = data.config;
    },

    //*- - - - - - - - 筛选配置 - - - - - - - - -

    async getSXDialog(type, item) {
      if (type === 0) {
        this.dpSX.title = item.name;
        this.dpSX.type = item.type;
        this.dpSX.oldItem = JSON.stringify(item);
        this.dpSX.config = JSON.parse(JSON.stringify(item.config));
        if (this.dpSX.type === '0') {
          await this.getDPSXconvStrPD(item);
        } else if (this.dpSX.type === '1') {
          await this.getSXDisDatePD(item);
        } else if (this.dpSX.type === '2') {
          await this.getDPNumranPD(item);
        }
        this.dpSX.show = true;
      } else if (type === 1) {
        let data = JSON.parse(this.dpSX.oldItem);
        this.setChart.sxList[data.index] = JSON.parse(this.dpSX.oldItem);
        this.dpSX.show = false;
      } else if (type === 2) {
        let ditStr = [];
        this.dpSX.config.ditStr.map((item) => {
          if (item.type && item.value) {
            ditStr.push(item)
          }
        });
        this.dpSX.config.ditStr = ditStr;
        let ditNum = [];
        this.dpSX.config.ditNum.map((item) => {
          if (item.type) {
            if (item.type === '区间') {
              if (item.q1 && item.q2) {
                ditNum.push(item);
              }
            } else {
              if (item.value) {
                ditNum.push(item);
              }
            }
          }
        });
        this.dpSX.config.ditNum = ditNum;
        let data = JSON.parse(this.dpSX.oldItem);
        this.setChart.sxList[data.index].config = JSON.parse(JSON.stringify(this.dpSX.config));
        this.dpSX.show = false;
        await this.getRendCharts();
      }
    },
    //筛选 重置
    getSXReset() {
      let data = JSON.parse(this.dpSX.oldItem);
      this.dpSX.config = data.config;
    },
    //筛选 字符串 常规筛选判断
    async getDPSXconvStrPD(item) {
      if (!item.config.strbool) {
        await this.getDPSXconvStrList();
      } else {
        await this.getDPSXconvStrCheckAll(1);
      }
    },
    //筛选 字符串 常规筛选 接口
    async getDPSXconvStrList() {
      await GetValuesByStringField({
        field: this.dpSX.title,
        dataSetId: this.ViewDP.id
      }).then(async res => {
        if (res.code === 200) {
          //弹框数据
          let config = this.dpSX.config;
          config.convStrFilList = res.data.listStr;
          config.convStrCheck = config.convStrFilList;
          config.strbool = true;
          //保存数据
          let data = JSON.parse(this.dpSX.oldItem);
          data.config = config;
          this.dpSX.oldItem = JSON.stringify(data);
          //复选框逻辑
          await this.getDPSXconvStrCheckAll(1);
        } else {
          //弹框数据
          let config = this.dpSX.config;
          config.convStrFilList = [];
          config.convStrCheck = [];
          config.strbool = false;
        }
      }).catch(() => {
        //弹框数据
        let config = this.dpSX.config;
        config.convStrFilList = [];
        config.convStrCheck = [];
        config.strbool = false;
      })
    },
    //筛选 字符串 常规筛选 复选框
    getDPSXconvStrCheckAll(type) {
      if (type === 0) {
        this.dpSX.config.convStrCheck = this.dpSX.configInit.convStrFil.checkAll ? this.dpSX.config.convStrFilList : [];
        this.dpSX.configInit.convStrFil.indCheck = false;
      } else if (type === 1) {
        let countAll = this.dpSX.config.convStrFilList.length;
        let count = this.dpSX.config.convStrCheck.length;
        if (count === countAll) {
          this.dpSX.configInit.convStrFil.checkAll = true;
          this.dpSX.configInit.convStrFil.indCheck = false;
        } else if (count < countAll && count !== 0) {
          this.dpSX.configInit.convStrFil.checkAll = false;
          this.dpSX.configInit.convStrFil.indCheck = true;
        } else if (count === 0) {
          this.dpSX.configInit.convStrFil.checkAll = false;
          this.dpSX.configInit.convStrFil.indCheck = false;
        }
      }
    },
    //筛选 字符串 条件筛选
    getDPSXDitStr(type, index) {
      if (type === 'add') {
        let count = 0;
        this.dpSX.config.ditStr.map((item) => {
          if (!item.type || !item.value) {
            count = 1;
          }
        });
        if (count !== 0) {
          this.getMsg('请完善已存在的【条件查询】数据', 'info');
          return;
        }
        this.dpSX.config.ditStr.push({ type: '', value: '' });
      } else if (type === 'del') {
        this.dpSX.config.ditStr.splice(index, 1);
      }
    },
    //筛选 数字 条件筛选
    getDPSXDitNum(type, index) {
      if (type === 'add') {
        let count = 0;
        this.dpSX.config.ditNum.map((item) => {
          if (item.type) {
            if (item.type === '区间') {
              if (!item.q1 || !item.q2) {
                count = 1;
              }
            } else {
              if (!item.value) {
                count = 1;
              }
            }
          } else {
            count = 1;
          }
        });
        if (count !== 0) {
          this.getMsg('请完善已存在的【条件查询】数据', 'info');
          return;
        }
        this.dpSX.config.ditNum.push({ type: '', value: '', q1: '', q2: '' });
      } else if (type === 'del') {
        this.dpSX.config.ditNum.splice(index, 1);
      }
    },
    //筛选 数字 范围筛选判断
    async getDPNumranPD(item) {
      if (!item.config.numbool) {
        await this.getDPNumranPDList();
      }
    },
    //筛选 数字 范围筛选
    async getDPNumranPDList() {
      await GetValuesByNumberField({
        field: this.dpSX.title,
        dataSetId: this.ViewDP.id
      }).then(res => {
        if (res.code === 200) {
          let config = this.dpSX.config;
          config.ranNum = res.data.listStr;
          config.ranNumSTEN.start = config.ranNum[0];
          config.ranNumSTEN.end = config.ranNum[1];
          config.numbool = true;
          //保存数据
          let data = JSON.parse(this.dpSX.oldItem);
          data.config = config;
          this.dpSX.oldItem = JSON.stringify(data);
        } else {
          let config = this.dpSX.config;
          config.ranNum = [0, 100];
          config.ranNumSTEN.start = config.ranNum[0];
          config.ranNumSTEN.end = config.ranNum[1];
          config.numbool = false;
        }
      }).catch(() => {
        let config = this.dpSX.config;
        config.ranNum = [0, 100];
        config.ranNumSTEN.start = config.ranNum[0];
        config.ranNumSTEN.end = config.ranNum[1];
        config.numbool = false;
      })
    },
    //筛选 数字 范围筛选判断
    async getSXDisDatePD(item) {
      if (!item.config.datebool) {
        await this.getSXDisDateList();
      }
    },
    //筛选 日期 离散时间 接口
    async getSXDisDateList() {
      await GetValuesByDateField({
        field: this.dpSX.title,
        dataSetId: this.ViewDP.id
      }).then(res => {
        let config = this.dpSX.config;
        config.disDateFil = [];
        config.disDateFil = res.data;
        config.disDateFil.unshift({
          type: '默认',
          values: []
        });
        this.dpSX.config.disDateType = '默认';
        config.datebool = true;
        //保存数据
        let data = JSON.parse(this.dpSX.oldItem);
        data.config = config;
        this.dpSX.oldItem = JSON.stringify(data);
      }).catch(() => {
        let config = this.dpSX.config;
        config.disDateFil = [{
          type: '默认',
          values: []
        }];
      });
      await this.getSXDisDateType();
    },
    //筛选 日期 离散时间选择数据
    async getSXDisDateType() {
      let configInit = this.dpSX.configInit.disDateLs;
      let config = this.dpSX.config;
      config.disDateFil.map((item) => {
        if (item.type === config.disDateType) {
          configInit.list = item.values;
        }
      });
      await this.getDPSXconvDateCheckAll(2);
    },
    //筛选 日期 离散时间 复选框 0 点击全选 1 点击单个子元素 2 全选
    getDPSXconvDateCheckAll(type) {
      if (type === 0) {
        let configInit = this.dpSX.configInit.disDateLs;
        let config = this.dpSX.config;
        config.disDateCheck = configInit.checkAll ? configInit.list : [];
        configInit.indCheck = false;
      } else if (type === 1) {
        let configInit = this.dpSX.configInit.disDateLs;
        let countAll = configInit.list.length;
        let count = this.dpSX.config.disDateCheck.length;
        if (count === countAll) {
          configInit.checkAll = true;
          configInit.indCheck = false;
        } else if (count < countAll && count !== 0) {
          configInit.checkAll = false;
          configInit.indCheck = true;
        } else if (count === 0) {
          configInit.checkAll = false;
          configInit.indCheck = false;
        }
      } else if (type === 2) {
        let configInit = this.dpSX.configInit.disDateLs;
        configInit.checkAll = true;
        this.getDPSXconvDateCheckAll(0);
      }
    },
    //获取时间
    getSTENDate(date) {
      let date1 = new Date(date[0]);
      let date2 = new Date(date[1]);
      let m1 = date1.getMonth() + 1;
      let m2 = date2.getMonth() + 1;
      let d1 = date1.getDate();
      let d2 = date2.getDate();
      return [
        `${date1.getFullYear()}-${m1 < 10 ? '0' + m1 : m1}-${d1 < 10 ? '0' + d1 : d1}`,
        `${date2.getFullYear()}-${m2 < 10 ? '0' + m2 : m2}-${d2 < 10 ? '0' + d2 : d2}`
      ];
    },

    //*- - - - - - - - 生成图表 - - - - - - - - -

    //根据条件 接口
    async getFilCharts() {
      this.clicktimes = 0;
      this.softContent = localStorage.getItem('softContent');
      let returnData = {};
      this.state.viewDP.load = true;
      let data = await this.getFilChartsParam();
      let optionChart = this.state.viewDP.chart.option;
      if (optionChart.minWDLength > data.wdFields.length || data.wdFields.length > optionChart.maxWDLength) {
        this.state.viewDP.noData = true;
        return returnData;
      }
      if (optionChart.minDLLength > data.zbFields.length || data.zbFields.length > optionChart.maxDLLength) {
        this.state.viewDP.noData = true;
        return returnData;
      }
      await GetEchartsData(data).then(res => {
        if (res.code === 200) {
          this.newArr = []
          returnData = res.data;
          this.state.viewDP.noData = false;
          if (this.dataPage == 2) {
            var dt = res.data.dataTabel.dt
            var myList = []
            for (var i = 0; i < res.data.dataTabel.head.listZB.length; i++) {
              myList.push(res.data.dataTabel.head.listZB[i].alias)
              myList = myList
            }
            var sum = 0
            var aaa = []
            var max = Math.abs(dt[0][myList[0]])
            for (var i = 0; i < dt.length; i++) {
              for (var j = 0; j < myList.length; j++) {
                if (max < Math.abs(dt[i][myList[j]])) {
                  max = Math.abs(dt[i][myList[j]])
                }
                if (dt[i][myList[j]] < 0) {
                  this.$store.state.viewDP.chart.setting.params.axios.yAxios.yAxios[0].min = -max
                }
              }
            }
          }
          if (this.dataPage == 3) {
            this.excelList = res.data.dataTabel.dt
            this.listWD = res.data.dataTabel.head.listWD[0].alias
            this.listZB = res.data.dataTabel.head.listZB[0].alias
            var myList = []
            for (var i = 0; i < res.data.dataTabel.head.listZB.length; i++) {
              myList.push(res.data.dataTabel.head.listZB[i].alias)
              this.myList = myList
            }
            var sum = 0
            var aaa = []
            for (var i = 0; i < this.excelList.length; i++) {
              for (var j = 0; j < this.myList.length; j++) {
                aaa.push(this.excelList[i][this.myList[j]])
                if (typeof (this.excelList[i][this.myList[j]]) == 'number') {
                  sum = sum + this.excelList[i][this.myList[j]]
                } else {
                  sum = "NaN"
                }
              }
            }
            this.sum = sum
            var bbb = []
            for (i = 0; i < this.myList.length; i++) {
              for (var j = 0; j <= aaa.length; j++) {
                if (0 <= this.myList.length * j - i && this.myList.length * j - i < aaa.length) {
                  bbb.push(aaa[this.myList.length * j - i])
                }
              }
            }
            let arrLength = bbb.length;
            let num = bbb.length / this.myList.length;
            let index = 0;
            for (var i = 0; i < arrLength; i++) {
              if (i % num === 0 && i !== 0) {
                this.newArr.push(bbb.slice(index, i));
                index = i;
              };
              if ((i + 1) === arrLength) {
                this.newArr.push(bbb.slice(index, (i + 1)));
              }
            };
            let arrAs = []
            for (var i = 0; i < this.newArr.length; i++) {
              arrAs.push(this.newArr[i])
            }
            var c = 0;
            var dlAdd = []
            for (var j = 0; j < this.newArr.length; j++) {
              for (var i = 0; i < this.newArr[j].length; i++) {
                c = c + this.newArr[j][i]
              }
              dlAdd.push(c)
              this.dlAdd = dlAdd;
              c = 0;
            }
            let numLength = arrAs.length;
            let arrst1 = [];
            if (arrAs) {
              for (var i = 0; i < arrAs[0].length; i++) {
                var anum = 0;
                for (var j = 0; j < numLength; j++) {
                  anum += arrAs[j][i]
                }
                arrst1.push(anum)
              }
              this.arrst1 = arrst1;
            }
          }
        } else {
          this.state.viewDP.noData = true;
        }
      }).catch(() => {
        this.state.viewDP.noData = true;
      });
      return returnData;
    },
    //下钻按钮
    //根据条件 获取参数
    getFilChartsParam() {
      //维度
      let wdFields = [];
      //度量
      let zbFields = [];
      //筛选
      let screenFields = [];
      //排序
      let orderFileds = [];
      //钻取
      // let softClasses ={};
      this.setChart.wdList.map((item) => {
        for (var i = 0; i < this.ViewDP.ColumnList.length; i++) {
          if (item.name === this.ViewDP.ColumnList[i].menuName) {
            this.ifDrill = 1;
            return;
          } else {
            this.ifDrill = 0;
          }
        }
      })
      try {
        //维度
        this.setChart.wdList.map((item) => {
          wdFields.push({
            filedName: item.name,
            filedType: parseInt(item.type),
            fieldAlog: item.config.calc,
            // fieldAlog: "默认",
            fieldAlias: item.config.alias,
            // fieldAlias: "",
          });
          let order = 0;
          if (item.config.order === '默认') {
            order = 0;
          } else if (item.config.order === '升序') {
            order = 1;
          } else if (item.config.order === '降序') {
            order = 2;
          }
          orderFileds.push({
            field: item.name,
            order: order
          })
        });
        //度量
        this.setChart.dlList.map((item) => {
          zbFields.push({
            filedName: item.name,
            filedType: parseInt(item.type),
            fieldAlog: item.config.calc,
            // fieldAlog: "总数",
            fieldAlias: item.config.alias,
            // fieldAlias: "sum",

          });
          let order = 0;
          if (item.config.order === '默认') {
            order = 0;
          } else if (item.config.order === '升序') {
            order = 1;
          } else if (item.config.order === '降序') {
            order = 2;
          }
          orderFileds.push({
            field: item.name,
            order: order
          })
        });
        //筛选
        this.setChart.sxList.map((item) => {
          let config = item.config;
          //0 字符 1 日期 2 数字
          if (item.type === '0' || item.type === 0) {
            if (config.strbool) {
              let alogAddedValue = [];
              try {
                alogAddedValue = this.listNoRepeat(config.convStrFilList, config.convStrCheck);
              } catch (e) {
                alogAddedValue = [];
              }
              if (alogAddedValue.length) {
                screenFields.push({
                  screeningField: item.name,
                  screeningFieldType: parseInt(item.type),
                  screenType: 0,
                  algorithm: '',
                  alogAddedValue: alogAddedValue,
                })
              }
            }
            if (config.ditStr.length) {
              config.ditStr.map((a) => {
                screenFields.push({
                  screeningField: item.name,
                  screeningFieldType: parseInt(item.type),
                  screenType: 1,
                  algorithm: a.type,
                  alogAddedValue: [a.value],
                })
              })
            }
            screenFields.push({
              screeningField: item.name,
              screeningFieldType: parseInt(item.type),
              screenType: 2,
              algorithm: '',
              alogAddedValue: [config.nullVal],
            })
          } else if (item.type === '1' || item.type === 1) {
            if (config.timDate.length === 2) {
              screenFields.push({
                screeningField: item.name,
                screeningFieldType: parseInt(item.type),
                screenType: 0,
                algorithm: '',
                alogAddedValue: this.getSTENDate(config.timDate),
              })
            }
            if (config.datebool) {
              if (config.disDateType !== '默认' && config.disDateType && config.disDateType) {
                let alogAddedValue = [];
                try {
                  alogAddedValue = this.listNoRepeat(this.dpSX.configInit.disDateLs.list, config.disDateCheck);
                } catch (e) {
                  alogAddedValue = [];
                }
                if (alogAddedValue.length) {
                  screenFields.push({
                    screeningField: item.name,
                    screeningFieldType: parseInt(item.type),
                    screenType: 0,
                    algorithm: config.disDateType,
                    alogAddedValue: alogAddedValue,
                  })
                }
              }
            }
            screenFields.push({
              screeningField: item.name,
              screeningFieldType: parseInt(item.type),
              screenType: 2,
              algorithm: '',
              alogAddedValue: [config.nullVal],
            })
          } else if (item.type === '2' || item.type === 2) {
            if (config.numbool) {
              screenFields.push({
                screeningField: item.name,
                screeningFieldType: parseInt(item.type),
                screenType: 0,
                algorithm: '',
                alogAddedValue: config.ranNum,
              })
            }
            if (config.ditNum.length) {
              config.ditNum.map((a) => {
                if (a.type === '区分') {
                  screenFields.push({
                    screeningField: item.name,
                    screeningFieldType: parseInt(item.type),
                    screenType: 1,
                    algorithm: a.type,
                    alogAddedValue: [a.q1, a.q2],
                  })
                } else {
                  screenFields.push({
                    screeningField: item.name,
                    screeningFieldType: parseInt(item.type),
                    screenType: 1,
                    algorithm: a.type,
                    alogAddedValue: [a.value],
                  })
                }
              });
            }
            screenFields.push({
              screeningField: item.name,
              screeningFieldType: parseInt(item.type),
              screenType: 2,
              algorithm: '',
              alogAddedValue: [config.nullVal],
            })
          }
        });
        if (this.dataPage == 1) {
          var opt1 = 0
          var opt2 = 0
          var opt3 = 0
          this.value1 = 0
          if (this.setChart.wdList.length == 0) {
            this.mbxList = []
          }
          if (this.setChart.dlList.length == 0) {
            this.mbxList = []
          }

          return {
            wdFields: wdFields,
            zbFields: zbFields,
            screenFields: screenFields,
            orderFileds: orderFileds,
            dataSetID: this.ViewDP.id,
            softContent: this.softContent,
            softCount: this.mbxList.length,
            ifDrill: this.ifDrill,
            pageInfo: {
              pageID: this.dataPage,
              obType: opt1,
              analysisType: opt2,
              qoqYoy: opt3,
              obDate: this.value1,
            }
          };
        } else if (this.dataPage == 2) {
          if (!this.options1) {
            this.getMsg('请选择观测周期');
            return;
          }
          if (this.radio == 2 && !this.value1) {
            this.getMsg('请选择观测时期');
            return;
          }
          if (!this.options2) {
            this.getMsg('请选择分析类型');
            return;
          }
          if (this.options1 == "年度观测") {
            var opt1 = 0;
          } else if (this.options1 == "月度观测") {
            var opt1 = 1;
          } else if (this.options1 == "日度观测") {
            var opt1 = 2;
          }
          if (this.options2 == "无") {
            var opt2 = 0;
          } else if (this.options2 == "增长率") {
            var opt2 = 1;
          } else if (this.options2 == "发展速度") {
            var opt2 = 2;
          }
          if (this.radio == "1") {
            var opt3 = 1;
          } else if (this.radio == "2") {
            var opt3 = 2;
          }
          return {
            wdFields: wdFields,
            zbFields: zbFields,
            screenFields: screenFields,
            orderFileds: orderFileds,
            dataSetID: this.ViewDP.id,
            softContent: this.softContent,
            softCount: this.mbxList.length,
            ifDrill: this.ifDrill,
            analysisType: opt2,
            obType: opt1,
            qoqYoy: opt3,
            obDate: this.value1,
            pageInfo: {
              pageID: this.dataPage,
              obType: opt1,
              analysisType: opt2,
              qoqYoy: opt3,
              obDate: this.value1,
            }
          };
        } else if (this.dataPage == 3) {
          var opt1 = 0
          var opt2 = 0
          var opt3 = 0
          this.value1 = 0
          return {
            wdFields: wdFields,
            zbFields: zbFields,
            screenFields: screenFields,
            orderFileds: orderFileds,
            dataSetID: this.ViewDP.id,
            softContent: this.softContent,
            softCount: this.mbxList.length,
            ifDrill: this.ifDrill,
            pageInfo: {
              pageID: this.dataPage,
              obType: opt1,
              analysisType: opt2,
              qoqYoy: opt3,
              obDate: this.value1,
            }
          };
        }
      } catch (e) {
        if (this.dataPage == 1) {
          return {
            wdFields: [],
            zbFields: [],
            screenFields: [],
            orderFileds: [],
            dataSetID: this.ViewDP.id,
            softContent: "",
            // viewsName: "",
            softCount: "",
            ifDrill: "",
          };
        } else if (this.dataPage == 2) {
          return {
            wdFields: [],
            zbFields: [],
            screenFields: [],
            orderFileds: [],
            dataSetID: this.ViewDP.id,
            softContent: "",
            // viewsName: "",
            softCount: "",
            ifDrill: "",
            analysisType: "",// 分析类型0:无（和普通查询无异，所以其他页面下调用传0） 1:增长率 2:发展速度
            obType: "",// 观测类型0:年度 1:月度 2:日度
            qoqYoy: "",// 0: 默认 1: 环比 2: 同比 
            obDate: "",

          };
        } else if (this.dataPage == 3) {
          return {
            wdFields: [],
            zbFields: [],
            screenFields: [],
            orderFileds: [],
            dataSetID: this.ViewDP.id,
            softContent: "",
            // viewsName: "",
            softCount: "",
            ifDrill: "",
          };
        }
      }
    },
    //查询所有图表
    getChartsAll() { //标签
      let list = [];
      for (let i in modules) {
        if (modules[i].viewType) {
          list.push({
            type: modules[i].type,
            name: modules[i].name,
            icon: modules[i].iconImg,
            chil: modules[i].chilCharts,
            sort: modules[i].sort || 999,
            minWDLength: modules[i].option.minWDLength,
            minDLLength: modules[i].option.minDLLength,
            maxWDLength: modules[i].option.maxWDLength,
            maxDLLength: modules[i].option.maxDLLength
          })
        }
      }
      list.sort((obj1, obj2) => {
        let val1 = obj1['sort'];
        let val2 = obj2['sort'];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
        }
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      }
      );


      this.rigConfig.list = list;
    },
    //渲染图表
    async getRendCharts() {
      this.getCheckWDFie();
      if (!this.charts.type && !this.charts.name) {
        this.state.viewDP.load = false;
        this.state.viewDP.noData = true;
        return;
      }
      //已操作
      this.viewDPOpera = 1;
      let data = await this.getFilCharts();
      if (!this.isNull(data)) {
        if (!this.state.viewDP.chart.comp.show) {
          this.state.viewDP.dom = document.getElementById('view_chartID');
        } else {
          this.state.viewDP.dom = '自定义图表';
        }
        this.state.viewDP.chart.data = data;
        this.$store.dispatch('viewDPRender');
      } else {
        this.state.viewDP.chart.data = '';
        setTimeout(() => {
          this.state.viewDP.load = false;
        }, 300)
      }
    },
    //点击图表
    async getClickCharts(type, name, state) {
      if (this.charts.type === type && this.charts.name === name) {
        return;
      }
      let charts = modules[type];
      this.$refs[`popover_${type}`][0] && this.$refs[`popover_${type}`][0].doClose();
      //子集数据
      let dataParam = {};
      modules[type].chilCharts.map((item) => {
        if (item.name === name) {
          dataParam = item;
        }
      });
      //维度参数 默认
      let wdParamsNow = JSON.parse(JSON.stringify(charts.wdHandle(charts.option)));
      this.charts.wdParams = this.getDGCopy(wdParamsNow, dataParam.wdParam);
      //度量参数 默认
      let dlParamsNow = JSON.parse(JSON.stringify(charts.dlHandle(charts.option)));
      this.charts.dlParams = this.getDGCopy(dlParamsNow, dataParam.dlParam);

      if (state !== '详情') {
        //基本参数
        let paramsNow = JSON.parse(JSON.stringify(charts.params(charts.option)));
        this.setChart.params = JSON.parse(JSON.stringify(await this.getDGCopy(paramsNow, dataParam.chartParam)));
        if (this.charts.type === type) {
          //维度
          for (let item of this.setChart.wdList) {
            item.params = JSON.parse(JSON.stringify(await this.getDGCopy(item.params, dataParam.wdParam)));
          }
          //度量
          let count = 0;
          for (let item of this.setChart.dlList) {
            item.params = JSON.parse(JSON.stringify(await this.getDGCopy(item.params, dataParam.dlParam)));
            if ((type === 'bar' || type === 'line' || type === 'scatter')
              && name === '双轴图') {
              if (count % 2 === 0) {
                item.params['lTAxis'] = 0;
              } else {
                item.params['lTAxis'] = 1;
              }
            }
            count++;
          }
        } else {
          //维度参数
          for (let item of this.setChart.wdList) {
            item.params = JSON.parse(JSON.stringify(this.charts.wdParams));
          }
          //度量参数
          let count = 0;
          for (let item of this.setChart.dlList) {
            item.params = JSON.parse(JSON.stringify(this.charts.dlParams));
            if ((type === 'bar' || type === 'line' || type === 'scatter')
              && name === '双轴图') {
              if (count % 2 === 0) {
                item.params['lTAxis'] = 0;
              } else {
                item.params['lTAxis'] = 1;
              }
            }
            count++;
          }
        }
      }
      this.cenBmPrompt = dataParam.viewDpPrompt ? dataParam.viewDpPrompt : dataParam.name ? '当前图表为' + dataParam.name : '';
      this.charts.type = charts.type;
      this.charts.name = name;


      charts.configModule.map((item) => {
        item.show = true;
      });

      let moduleList = charts.configModule;
      if (dataParam.isNoModuleName) {
        dataParam.isNoModuleName.map((item) => {
          moduleList.map((node, index) => {
            if (item === node.name) {
              node.show = false;
            }
          })
        });
      }

      this.charts.showComPonent = false;
      if (charts.option.isComConfig) {
        this.charts.showComPonent = true;
      }

      this.charts.component = moduleList;
      this.charts.wdComponent = charts.wdComponent;
      this.charts.dlComponent = charts.dlComponent;
      this.state.viewDP.nowChart.type = charts.type;
      this.state.viewDP.nowChart.name = name;
      this.state.viewDP.chart.initOrig = charts;
      this.state.viewDP.chart.option = charts.option;
      this.state.viewDP.chart.comp.component = charts.component || null;
      this.state.viewDP.chart.comp.show = false;
      if (!this.state.viewDP.chart.comp.component) {
        this.state.viewDP.dom = document.getElementById('view_chartID');
      } else {
        this.state.viewDP.chart.comp.show = true;
        this.state.viewDP.dom = '自定义图表';
      }
      await this.$store.dispatch('viewDPRenderBefore');
      this.getRendCharts();
    },
    //多维分析名称校验
    async getNameRepeat(name) {
      if (this.type === '修改') {
        if (this.oldDetailsJSON.dataViewName === this.rigConfig.reportName) {
          return true;
        }
      }
      let bool = false;
      if (name) {
        this.rigConfig.reportName = name;
      }
      await GetDataViewNameVerify({
        dataViewName: this.rigConfig.reportName,
        dataSetID: this.ViewDP.id
      }).then(res => {
        if (res.code === 200) {
          bool = true;
        }
      });
      return bool;
    },
    //保存之前
    async getSave() {
      if (this.rigConfig.reportName) {
        this.getSaveAfter(0);
      } else {
        this.$prompt('多维分析名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnPressEscape: false,
          closeOnClickModal: false,
          customClass: 'alert_allCom',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              if (!instance.inputValue) {
                this.getMsg('请输入多维分析名称');
              } else {
                if (await this.getNameRepeat(instance.inputValue)) {
                  done();
                }
              }
              return false;
            } else {
              done();
            }
          }
        }).then(({ value }) => {
          this.getSaveAfter(1);
        }).catch(() => {

        });
      }
    },
    //保存
    async getSaveAfter(type) {
      this.allLoad = true;
      if (type === 0) {
        if (await this.getNameRepeat()) {
          await this.getSaveImg();
        }
      } else {
        await this.getSaveImg();
      }
    },
    //下载图表
    async getSaveImg() {
      /*图片跨域及截图模糊处理*/
      html2canvas(document.querySelector("#img_canvas_viewDp")).then(async canvas => {
        let baseData = canvas.toDataURL("image/jpeg", 1.0);
        let blob = this.dataURItoBlob(baseData);
        let form = new FormData();
        form.append("file", blob);
        await UploadPreviewPictureAsync(form).then(res => {
          if (res.code === 200) {
            this.charts.imgHref = res.data.webFilePath;
          } else {
            this.charts.imgHref = '';
          }
        });
        await this.getSaveJK();
      }).catch(() => {
        this.getSaveJK();
      });
    },
    //保存接口
    async getSaveJK() {
      let json = await this.getFilChartsParam();
      let data = JSON.parse(JSON.stringify(json));
      data['viewModel'] = {
        dataViewName: this.rigConfig.reportName,
        dataSetID: this.ViewDP.id,
        dataSourceID: this.ViewDP.sourceId,
        chartType: this.nowChart.type,
        chartName: this.nowChart.name,
        returnData: JSON.stringify(this.state.viewDP.chart.data),
        requestJson: await this.getJSONVal(json),
        previewPicture: this.charts.imgHref || null,
      };
      if (this.type === '修改') {
        data['viewModel']['id'] = this.oldDetailsJSON.id;
      }
      SaveCharts(data).then(res => {
        if (res.code === 200) {
          this.viewDPOpera = 0;
          this.getMsg('保存成功', 'success');
          this.$router.push('/viewSet')
        }
      }).catch(() => {

      });
      setTimeout(() => {
        this.allLoad = false;
      }, 300)
    },
    //保存的JSON数据
    getJSONVal(json) {
      let data = {
        setting: this.setChart,
        nowChart: this.state.viewDP.nowChart
      };
      return JSON.stringify(data);
    },
    //封装blob对象
    dataURItoBlob(baseData) {
      let byteString;
      if (baseData.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(baseData.split(',')[1]);
      else
        byteString = unescape(baseData.split(',')[1]);
      let mimeString = baseData.split(',')[0].split(':')[1].split(';')[0];
      let ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    //获取详情
    async getDetailsChart(dataViewID) {
      await GetDataViewByID({ dataViewID: dataViewID }).then(async res => {
        if (res.code === 200) {
          let data = res.data[0];
          this.oldDetailsJSON = JSON.parse(JSON.stringify(data));
          this.rigConfig.reportName = data.dataViewName;
          let chartJSON = JSON.parse(data.requestJson);
          let charts = modules[chartJSON.nowChart.type];
          this.state.viewDP.chart.initOrig = charts;
          await this.$store.dispatch('viewDPGetDataVal', chartJSON);
          this.getClickCharts(chartJSON.nowChart.type, chartJSON.nowChart.name, '详情');
          this.dataPage = data.pageInfo.pageID;
          if (data.pageInfo.obType == 0) {
            this.options1 = "年度观测";
          } else if (data.pageInfo.obType == 1) {
            this.options1 = "月度观测";
          } else if (data.pageInfo.obType == 2) {
            this.options1 = "日度观测";
          }
          if (data.pageInfo.analysisType == 0) {
            this.options2 = "无";
          } else if (data.pageInfo.analysisType == 1) {
            this.options2 = "增长率";
          } else if (data.pageInfo.analysisType == 2) {
            this.options2 = "发展速度";
          }
          if (data.pageInfo.qoqYoy == 1) {
            this.radio = "1";
          } else if (data.pageInfo.qoqYoy == 2) {
            this.radio = "2";
          }
          this.value1 = data.pageInfo.obDate
        }
      }).catch(async () => {
        // await this.getMsg('抱歉！页面渲染失败！');
        await this.getNoVal();
      });
      this.getCheckWDFie();
    }
  },
  watch: {
    option() {
      if (this.dataPage == 2 && !this.options1 && !this.options2) {
        // this.getClickCharts();
      }
    },
    'setChart.wdList.length': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          // 操作
          if (this.dataPage == 3 && this.setChart.wdList.length != 0) {
            var tables1 = document.getElementById("tables1")
            var tables2 = document.getElementById("tables2")
            if (tables1) {
              tables1.style.display = "table"
            }
            if (tables2) {
              tables2.style.display = "table"
            }

            this.getFilCharts();
          }
          if (this.setChart.wdList.length == 0 && this.dataPage == 3) {
            this.listWD = ""
          }
        }
      }
    },
    'setChart.dlList.length': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          // 操作
          if (this.dataPage == 3 && this.setChart.wdList.length != 0) {
            var tables1 = document.getElementById("tables1")
            var tables2 = document.getElementById("tables2")
            if (tables1) {
              tables1.style.display = "table"
            }
            if (tables2) {
              tables2.style.display = "table"
            }

            this.getFilCharts();
          }
          if (this.setChart.wdList.length == 0 && this.dataPage == 3) {
            this.myList = [];
            this.excelList = []
          }
        }
      }
    }
  },
  created() {
    window.xz = this.xz;
    window.sz = this.sz;
  },
  mounted() {
    // window.getFilCharts=this.getFilCharts();
    this.init();
  },
  computed: {
    state() {
      return this.$store.state;
    },
    setChart() {
      return this.$store.state.viewDP.chart.setting;
    },
    nowChart() {
      return this.$store.state.viewDP.nowChart || {};
    }

  },
  destroyed() {

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      //多维分析
      vm.$store.state.dpType = 0;
    });
  },
  beforeRouteLeave(to, from, next) {
    let count = 0;
    for (let i in setConfigAll.routePath) {
      if (i === '数据处理') {
        setConfigAll.routePath[i].map((item) => {
          if (item.path === to.path) {
            count = 1;
          }
        })
      }
    }
    if (count !== 0) {
      if (this.viewDPOpera === 0) {
        return next();
      }
      if (this.setChart.wdList.length || this.setChart.dlList.length || this.setChart.sxList.length) {
        this.$alert('你确定要离开当前页面吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          customClass: 'alert_allCom',
        }).then(() => {
          next();
        }).catch(() => {
          next(false);
        });
      } else {
        next();
      }
    } else {
      next();
    }
  },
}
</script>

<style lang="less">
@borderRadio: 5px;
@borderColor: #ccc;
@shadow: 0 0 15px @h_top_backColor;
@conBackWLS: #eaeaea;
@cenMargin: 15px;
@minMargin: 20px;
@saveHeight: 80px;

.createViewDP {
  display: grid;
  grid-template-columns: 230px auto;
  padding-right: 20px;
  .main {
    height: 100%;
    // width: 1670px;
    width: 100%;
    float: left;
    display: inline-block;
    background-color: #e0e1ec;
    border-radius: 10px;
    // padding: 20px;
    padding-left: 10px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    .dataDiy {
      height: 63px;
      width: 100%;
      line-height: 50px;
      font-size: 18px;
      background-color: #e0e1ec;
      span {
        margin-right: 60px;
      }

      .FBtn {
        float: right;
      }
    }
    .dataPage {
      border-bottom: 2px solid #002774;
      color: #002774;
    }
  }

  .leftViewDP {
    width: 286px;
    height: 100%;
    margin-right: @minMargin;
    float: left;

    .noSelect;

    .leftTil {
      background-color: @h_path_backColor;
      border-radius: @borderRadio;
      padding: 7px 0px;
      line-height: 30px;
      position: relative;

      .FSpanTil {
        vertical-align: middle;
        max-width: 80%;

        .div_svg {
          margin-top: 0;
        }
      }

      .divSvg {
        display: inline-block;
        float: right;
        width: 30px;
        height: 30px;
      }
      ul {
        li {
          height: 40px;
          line-height: 40px;
          padding-left: 50px;
        }
        li:hover {
          background-color: rgba(0, 36, 116, 0.1);
        }
        .activeClass {
          background-color: rgba(0, 36, 116, 0.2);
        }
      }
    }

    .leftList {
      margin: 15px 0;
      display: inline-block;
      width: 100%;
      // height: calc(100% - 15px - 30px - 14px);
      background-color: @h_path_backColor;
      border-radius: @borderRadio;

      .list_til {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-top-right-radius: @borderRadio;
        border-top-left-radius: @borderRadio;
        // background-color: hsl(@green, 90%);
        background-color: #002774;
        padding: 0 10px;
        white-space: normal;

        .divSvg {
          display: inline-block;
          float: left;
          width: 30px;
          height: 30px;

          > .FSvg {
            cursor: auto;
          }
        }

        .divSpan {
          color: #fff;
          display: inline-block;
          width: calc(100% - 60px);
          .text_oneLine;
          float: left;
          font-size: 16px;
          letter-spacing: 2px;
          margin-left: 10px;
        }
      }

      .listUl_count {
        width: 100%;
        height: calc(100% - 40px);
        overflow-y: auto;
        overflow-x: hidden;

        .listUl {
          width: 100%;
          height: 100%;

          > li {
            width: 100%;
            line-height: 40px;
            padding: 0 10px;
            color: hsl(@fontColor, 0.8);
            font-size: 16px;
            cursor: pointer;
            letter-spacing: 1px;
            display: inline-block;

            .FSvg {
              width: 20px;
              margin-right: 7px;
              float: left;

              > div {
                margin-top: -4px;
              }
            }

            .name_fie {
              display: inline-block;
              float: left;
              width: calc(100% - 70px);
              .text_oneLine;
            }

            .WDMark {
              float: left;
              display: inline-block;
              width: 40px;
              text-align: center;
              color: @green;
            }
          }

          > li:hover {
            background-color: rgba(0, 36, 116, 10%);
          }

          .glClass {
            background-color: rgba(0, 36, 116, 20%);
          }

          .addValList {
            background-color: hsl(@green, 30%) !important;
          }
        }
      }
    }
    .refine {
      //   background-color: @h_path_backColor;
      background: #002774;
      color: #fff;
      border-radius: @borderRadio;
      padding: 7px 5px;
      line-height: 30px;
      position: relative;
      margin-top: 15px;

      .FSpanTil {
        vertical-align: middle;
        max-width: 80%;

        .div_svg {
          margin-top: 0;
        }
      }

      .divSvg {
        display: inline-block;
        float: right;
        width: 30px;
        height: 30px;
      }
    }
  }

  .cenViewDP,
  .cenViewDP2 {
    // background-color: @h_path_backColor;
    border-radius: @borderRadio;
    height: 100%;
    // width: calc(100% - 30% - @minMargin - 16% - @minMargin);
    width: calc(100% - 677px);
    float: left;
    margin-right: @minMargin;
    position: relative;
    overflow: auto;

    .amap-logo {
      display: none !important;
    }

    .tpCon {
      // height: 400px;
      width: 260px;
      margin-bottom: @cenMargin;
      display: inline-block;
      min-height: 275px;
      float: left;
      .compareKind {
        border: 1px solid @borderColor;
        border-radius: @borderRadio;
        min-height: 132px;
        background: #fff;
        margin-bottom: 15px;
        padding: 10px 20px;
        .kind {
          display: grid;
          grid-template-columns: 85px auto;
          .type {
            display: block;
            height: 52px;
            line-height: 52px;
          }
          .el-radio-group {
            grid-template-columns: 75px auto;

            .el-radio:nth-of-type(1) {
              margin-right: 10px;
            }
            .el-radio__label {
              padding: 2px 5px;
            }
          }
        }
        .cycle {
          margin-bottom: 5px;
          div {
            margin-bottom: 10px;
          }
          // .el-input__inner {
          //   height: 30px;
          //   width: 130px;
          //   margin-left: 20px;
          // }
          // .el-input__icon {
          //   line-height: 30px;
          // }
        }
      }

      .tpCon_WL {
        float: left;
        width: 260px;
        height: 100%;
        margin-bottom: 15px;
      }

      .tpConWD,
      .tpConDL {
        // background-color: @conBackWLS;
        border: 1px solid @borderColor;
        border-radius: @borderRadio;
        float: left;
        display: inline-block;
        width: 260px;
        height: 223px;
        margin-bottom: @cenMargin;
        position: relative;

        > .div_for {
          > span {
            display: inline-block;
            letter-spacing: 1px;
          }

          .order_div {
            margin-left: 3px;
          }
        }
      }

      .tpConDL {
        margin-bottom: 0;
      }

      .tpConSX {
        // background-color: @conBackWLS;
        border: 1px solid @borderColor;
        border-radius: @borderRadio;
        width: 260px;
        height: 224px;
        float: right;
        float: left;
        display: inline-block;
        position: relative;
      }

      .tpConWD,
      .tpConDL,
      .tpConSX {
        padding: 5px 15px;
        background-color: #fff;

        > p {
          width: 100%;
          height: 30px;
          line-height: 30px;
          color: #666;
          letter-spacing: 2px;
          margin-bottom: 5px;
        }

        > div {
          display: inline-block;
          padding: 0 5px;
          letter-spacing: 1px;
          background-color: rgba(0, 184, 63, 0.7);
          border-radius: 3px;
          line-height: 25px;
          font-size: 12px;
          margin-right: 5px;
          margin-bottom: 5px;
          color: #fff;
          cursor: pointer;
          .noSelect;
        }

        > div:hover {
          background-color: rgba(0, 184, 63, 1);
        }
      }
    }

    .bmCharts,
    .bmCharts2 {
      width: calc(100% - 275px);
      background-color: #fff;
      // height: calc(100% - @cenMargin - 45% - 5px - 30px);
      border-radius: @borderRadio;
      border: 1px solid @borderColor;
      height: 650px;
      margin-left: 15px;
      float: left;
      position: relative;
      overflow: hidden;
      .mbx {
        position: absolute;
        top: 20px;
        right: 30px;
        .mbxSpan:hover {
          color: #002774;
          font-weight: bold;
          text-decoration: underline;
        }
        .xz {
          cursor: pointer;
          display: inline-block;
          width: 80px;
          height: 30px;
          background-color: #2468ee;
          line-height: 30px;
          text-align: center;
          color: #fff;
          border-radius: 5px;
          margin-left: 15px;
        }
      }

      #img_canvas_viewDp {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .chartsDP {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }

      .chart_repName {
        line-height: 30px;
        padding: 10px 20px;
        position: absolute;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 3px;
        top: 0;
        left: 0;
        width: 100%;
      }
    }
    .bmCharts2 {
      padding: 10px;
      width: 1025px;
      overflow-x: scroll;
      overflow-y: scroll;
      position: relative;
      .switchDiv {
        width: 100%;
        height: 40px;
        background: rgba(255, 255, 255, 0.8);
        position: sticky;
        top: 0;
      }
      .el-switch {
        float: right;
        margin-bottom: 10px;
        margin-left: 20px;
        margin-top: 10px;
      }

      #tables2 {
        max-height: 650px;
        width: 100%;
        border-collapse: collapse;
        // background: skyblue;
        text-align: center;
        tr {
          height: 60px;
        }
        tr:nth-of-type(1) {
          background: #cae8ea !important;
          border-radius: 10px;
          td {
            font-size: 16px;
          }
        }
        tr td:nth-of-type(1) {
          font-size: 16px;
        }
        tr:nth-of-type(odd) {
          background: #f5fafa;
        }
        td {
          height: 60px;
          vertical-align: middle;
          border: 1px solid #c1dad7;
          font-family: "Trebuchet MS", Verdana, Arial, Helvetica, sans-serif;
        }
        tr:nth-of-type(1):hover td {
          background: #cae8ea !important;
        }
        td:hover {
          background: #e6eae9;
          transition: background-color 0.1s linear;
        }
      }
      #tables1 {
        max-height: 650px;
        width: 100%;
        border-collapse: collapse;
        // background: skyblue;
        text-align: center;
        tr {
          height: 60px;
        }
        td {
          height: 60px;
          vertical-align: middle;
          border: 1px solid #c1dad7;
          font-family: "Trebuchet MS", Verdana, Arial, Helvetica, sans-serif;
        }
        tr td:nth-of-type(1) {
          background: #cae8ea !important;
          font-size: 16px;
        }
        tr td:nth-of-type(odd) {
          background: #f5fafa;
        }
        tr td:hover {
          background: #e6eae9;
          transition: background-color 0.1s linear;
        }
      }
    }
    .bmCharts2::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    /*定义滚动条轨道 内阴影+圆角*/
    .bmCharts2::-webkit-scrollbar-track {
      border-radius: 10px;
    }

    /*定义滑块 内阴影+圆角*/
    .bmCharts2::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #d2d2d2;
    }

    .bmPrompt {
      position: relative;
      overflow: hidden;
      color: #999;
      font-size: 15px;
      letter-spacing: 1px;
      line-height: 30px;
      padding: 0 5px;
      padding-top: 15px;
      text-align: right;
      height: 55px;
      .text_oneLine;
    }
    .save_div {
      // width: 100%;
      // height: @saveHeight;
      text-align: right;
      padding: 0 10px;
      display: inline-block;
      // position: absolute;
      right: 0;
      top: 10px;
      > .FBtn {
        // width: 100%;

        > div {
          height: 40px;

          span {
            float: none;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            // letter-spacing: 5px;
            text-align: center;
          }
        }
      }
    }
  }
  .cenViewDP2 {
    width: 1304px;
  }

  .rigViewDP {
    background-color: @h_path_backColor;
    border-radius: @borderRadio;
    height: 90%;
    width: 344px;
    float: left;
    border: 1px solid @borderColor;
    position: absolute;

    .rigViewDP_til {
      width: 100%;
      height: 50px;

      > span {
        width: 50%;
        line-height: 48px;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 3px;
        color: #002774;
        display: inline-block;
        float: left;
        text-align: center;
        cursor: pointer;
        border-bottom: 1px solid @borderColor;
        .text_oneLine;
        .noSelect;
      }

      > span:first-child {
        border-top-left-radius: @borderRadio;
        border-right: 1px solid @borderColor;
      }

      > span:last-child {
        border-top-right-radius: @borderRadio;
      }

      // > span:hover {
      //     background-color: hsl(@green, 20%);
      //     border-color: hsl(@green, 20%);
      // }

      .addSpan_til {
        // background-color: hsl(@green, 80%) !important;
        background-color: #002774;
        border-color: #002774;
        // border-color: hsl(@green, 80%) !important;
        color: #fff !important;
      }
    }

    .rigViewDP_count {
      width: 100%;
      height: calc(100% - 50px);

      .config_div {
        width: 100%;
        // height: calc(100% - @saveHeight);
        height: 100%;
        // border-bottom: 1px dashed @borderColor;
      }

      .config_div_left {
        .conLef_top {
          width: 100%;
          height: calc(100% - 80px);
          padding: 10px 10px;

          .el-scrollbar {
            width: 100%;
            height: 100%;

            .el-scrollbar__wrap {
              overflow-x: hidden;
            }
            /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
            // .el-scrollbar__wrap::-webkit-scrollbar {
            //   width: 4px;
            //   height: 4px;
            // }
            // /*定义滚动条轨道 内阴影+圆角*/
            // .el-scrollbar__wrap::-webkit-scrollbar-track {
            //   border-radius: 10px;
            // }

            // /*定义滑块 内阴影+圆角*/
            // .el-scrollbar__wrap::-webkit-scrollbar-thumb {
            //   border-radius: 10px;
            //   background-color: #d2d2d2;
            // }

            .is-horizontal {
              display: none;
            }

            .el-scrollbar__view {
              width: calc(100% + 10px);

              :focus {
                outline: -webkit-focus-ring-color auto 0;
              }

              .chart_d {
                width: calc(50% - 10px);
                margin-bottom: 10px;
                margin-right: 10px;
                padding: 10px 10px 0;
                float: left;
                cursor: pointer;
                border: 1px dashed transparent;

                > img {
                  width: 100%;
                  max-height: 102px;
                }

                > span {
                  text-align: center;
                  display: inline-block;
                  line-height: 30px;
                  font-size: 14px;
                  letter-spacing: 2px;
                  width: 100%;
                  .text_oneLine;
                }
              }

              .chart_d_disble {
                background-color: rgba(226, 226, 226, 0.35) !important;
                cursor: not-allowed !important;
                border-radius: @borderRadio;
                border: 1px dashed transparent !important;
                pointer-events: none;

                > span {
                  color: #b5b5b5;
                }
              }

              .addCharts {
                border: 1px dashed @green;
                border-radius: @borderRadio;
                background-color: hsl(@green, 5%);
              }

              .chart_d:hover {
                border: 1px dashed @green;
                border-radius: @borderRadio;
              }
            }
          }
        }

        .conLef_bom {
          height: 80px;
          padding: 10px 10px;
          width: 100%;
          border-top: 1px dashed @borderColor;

          p {
            line-height: 30px;
            font-size: 14px;
            white-space: nowrap;
            letter-spacing: 2px;
            color: @fontColor;
            .text_oneLine;

            span {
              color: @green;
              margin: 0 5px;
              display: inline-block;
            }
          }
        }
      }

      .config_div_rig {
        > .config_div_rig_div {
          width: 100%;
          height: 100%;
          overflow: auto;
          overflow-x: hidden;

          .configFlot {
            width: 100%;
            height: 100%;
            padding: 10px 0;

            .comDP_config {
              width: 100%;
              padding: 0 10px;
              margin-bottom: 10px;

              .config_comTop {
                width: 100%;
                margin-bottom: 10px;

                > span {
                  font-size: 14px;
                  color: @fontColor;
                  width: 100%;
                  line-height: 20px;
                  letter-spacing: 2px;
                  font-weight: bold;
                  margin-bottom: 5px;
                  .text_oneLine;
                  display: inline-block;
                  margin-left: 2px;
                }

                .btSpan:after {
                  content: "*";
                  margin-left: 2px;
                  color: @red;
                }

                .el-input__inner {
                  height: 30px;
                  line-height: 30px;
                  padding: 0 7px;
                  letter-spacing: 1px;
                }
              }

              .config_comTop:last-child {
                margin-bottom: 0;
              }
            }

            .folt_collapse {
              border: 0 !important;

              .FFoldBox__header {
                background-color: #eeeeee;
                color: @fontColor;
                line-height: 35px;
                padding: 0 10px;
                font-size: 14px;
                letter-spacing: 2px;
                font-weight: bold;
                border: 0 !important;
                height: 35px;
                margin: 5px 0 0;
              }

              .FFoldBox__wrap {
                border: 0 !important;
                background-color: transparent !important;
              }

              .el-icon-arrow-right:before {
                color: @fontColor;
              }

              .FFoldBox__content {
                padding: 0;
                color: @fontColor;
                background-color: transparent;
              }

              .wdl_ri_div {
                height: 90px;
                border: 1px solid #006688;
                border-radius: 2px;
                margin: 5px;
                margin-top: 10px;
                margin-bottom: 10px;
                width: calc(100% - 10px);
                padding: 7px;

                > div {
                  display: inline-block;
                  padding: 0 7px;
                  letter-spacing: 1px;
                  background-color: rgba(0, 184, 63, 0.7);
                  border-radius: 3px;
                  line-height: 25px;
                  font-size: 12px;
                  margin-right: 5px;
                  margin-bottom: 5px;
                  color: #fff;
                  cursor: pointer;
                }

                > div:hover {
                  background-color: rgba(0, 184, 63, 1);
                }
              }
            }
          }
        }
      }

      .save_div {
        width: 100%;
        height: @saveHeight;
        line-height: @saveHeight;
        text-align: center;
        padding: 0 10px;
        display: inline-block;

        > .FBtn {
          width: 100%;

          > div {
            height: 40px;

            span {
              float: none;
              height: 40px;
              line-height: 40px;
              font-size: 18px;
              letter-spacing: 5px;
            }
          }
        }
      }
    }
  }
  .two {
    width: 31px;
    height: 70px;
    // margin: 10px auto;
    border: 12px solid;
    /*边框颜色：上 右 下 左 （从上边框开始 顺时针方向）*/
    border-color: transparent #2468ee transparent transparent;
    /*为了兼容IE6，所有设置为透明（transparent）的边，需要设置为dashed；有颜色的边设置为solid*/
    border-style: dashed solid dashed dashed;
    position: absolute;
    left: -31px;
    top: calc(50% - 35px);
    span {
      display: inline-block;
      line-height: 40px;
      color: #fff;
      .FSvg {
        width: 15px !important;
        height: 50px !important;
        position: absolute;
        top: 0px;
        right: -14px;
      }
    }
  }

  .createViewDP_dialog {
    .el-dialog__body {
      padding: 0;

      .viewSet_dialog_count {
        padding: 0;
        width: 100%;
        height: 100%;

        .div_radio {
          padding: 15px 40px;
          overflow-y: auto;
          max-height: 500px;
          .tit {
            height: 24px;
            line-height: 24px;
            text-align: left;
            font-size: 24px;
            margin-bottom: 10px;
            color: #000;
            input {
              border-bottom: 1px solid #000;
              text-align: center;
              outline: none;
            }
          }

          .el-radio-group {
            width: 100%;

            .el-radio {
              width: 100%;
              line-height: 40px;
              margin-right: 0 !important;

              .el-radio__inner {
                width: 18px;
                height: 18px;
              }

              .el-radio__label {
                font-size: 18px;
                width: calc(100% - 50px);
                .text_oneLine;
                display: inline-block;
                vertical-align: middle;
                margin-left: 5px;
              }

              .el-radio__inner::after {
                width: 6px;
                height: 6px;
              }
            }
          }
        }
        .div_describe {
          padding: 0 30px;
          .left {
            width: 250px;
            height: 570px;
            background: #f5f5f5;
            .top {
              font-size: 18px;
              line-height: 50px;
              text-align: center;
            }
            ul li {
              width: 100%;
              line-height: 30px;
              font-size: 16px;
              text-align: left;
              padding: 0 0 0 50px;
              span {
              }
              .name_fie {
                margin-left: 10px;
              }
            }
            .glClass {
              background-color: rgba(0, 36, 116, 20%);
            }
          }
          .right {
            width: 420px;
            height: 570px;
            background: #f5f5f5;
            margin-left: 30px;
          }

          .right {
            padding: 15px 15px;
            > p {
              width: 100%;
              height: 30px;
              line-height: 30px;
              color: #666;
              letter-spacing: 2px;
              margin-bottom: 5px;
            }

            > div {
              width: 390px;
              height: 50px;
              text-align: center;
              line-height: 50px;
              display: inline-block;
              padding: 0 15px;
              letter-spacing: 1px;
              background-color: #fff;
              border-radius: 3px;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 10px;
              color: #000;
              cursor: pointer;
              .noSelect;
              .xuhao {
                font-size: 12px;
                display: inline-block;
                float: left;
                color: #fff;
                background: #ff872e;
                width: 30px;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                border-radius: 5px;
                font-weight: normal;
              }
            }

            > div:hover {
              background-color: skyblue;
            }
          }
          .right .div_for:nth-child(5n-4) .xuhao {
            background: #ff872e;
          }
          .right .div_for:nth-child(5n-3) .xuhao {
            background: #f76969;
          }
          .right .div_for:nth-child(5n-2) .xuhao {
            background: #4e76f0;
          }
          .right .div_for:nth-child(5n-1) .xuhao {
            background: #51b787;
          }
          .right .div_for:nth-child(5n) .xuhao {
            background: #ffcc1a;
          }
        }
        .div_btn {
          padding: 20px 10px;
          display: inline-block;
          width: 100%;
          text-align: right;
        }
      }
    }
  }

  .ViewDP_wd_dialog {
    .type_radio {
      display: inline-block;
      width: 100%;
      text-align: center;
      border-bottom: 2px solid #ddd;
      height: 40px;
      margin-bottom: 10px;

      > span {
        line-height: 35px;
        float: left;
        margin-right: 20px;
        font-size: 14px;
        letter-spacing: 1px;
        color: #a3a3a3;
        cursor: pointer;
        padding: 0 10px;
        text-align: left;
        .noSelect;
        font-weight: bold;
        border-bottom: 2px solid transparent;
        margin-top: 2px;
      }

      > span:hover {
        color: @green;
        font-weight: bold;
        border-bottom: 2px solid @green;
      }

      .addSpan {
        color: @green;
        font-weight: bold;
        border-bottom: 2px solid @green;
      }
    }

    .dialog_count {
      display: inline-block;
      width: 100%;

      .count_div {
        width: 100%;
        display: inline-block;
        padding: 5px 0;

        > .div_label {
          width: 100%;
          display: inline-block;
          margin-bottom: 10px;
          padding: 57px 15px 10px;
          // border: 1px solid @borderColor;
          border-bottom: 0;
          position: relative;

          > span {
            width: 100%;
            display: inline-block;
            line-height: 40px;
            height: 42px;
            font-size: 16px;
            letter-spacing: 2px;
            font-weight: bold;
            margin-bottom: 7px;
            background: #eeeeee;
            padding: 0 15px;
            position: absolute;
            top: 0;
            left: 0;
            .noSelect;
          }

          .el-radio {
            margin-bottom: 15px;
          }
        }

        .div_label:last-child {
          border-bottom: 1px solid @borderColor;
          margin-bottom: 0;
        }

        .noMar_label {
          margin-bottom: 0;
          padding-bottom: 0;
        }
      }
    }

    .div_btn {
      width: 100%;
      text-align: right;
      display: inline-block;
      margin-top: 12px;
    }
  }

  .ViewDP_dl_dialog {
    .type_radio {
      display: inline-block;
      width: 100%;
      text-align: center;
      border-bottom: 2px solid #ddd;
      height: 40px;
      margin-bottom: 10px;

      > span {
        line-height: 35px;
        float: left;
        margin-right: 20px;
        font-size: 14px;
        letter-spacing: 1px;
        color: #a3a3a3;
        cursor: pointer;
        padding: 0 10px;
        text-align: left;
        .noSelect;
        font-weight: bold;
        border-bottom: 2px solid transparent;
        margin-top: 2px;
      }

      > span:hover {
        color: @green;
        font-weight: bold;
        border-bottom: 2px solid @green;
      }

      .addSpan {
        color: @green;
        font-weight: bold;
        border-bottom: 2px solid @green;
      }
    }

    .dialog_count {
      display: inline-block;
      width: 100%;

      .count_div {
        width: 100%;
        display: inline-block;
        padding: 5px 0;

        > .div_label {
          width: 100%;
          display: inline-block;
          padding: 57px 15px 10px;
          // border: 1px solid @borderColor;
          border-bottom: 0;
          position: relative;

          > span {
            width: 100%;
            display: inline-block;
            line-height: 40px;
            height: 42px;
            letter-spacing: 2px;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 7px;
            background: #eeeeee;
            padding: 0 15px;
            position: absolute;
            top: 0;
            left: 0;
            .noSelect;
          }

          .el-radio {
            margin-bottom: 15px;
          }
        }

        .div_label:last-child {
          // border-bottom: 1px solid @borderColor;
          margin-bottom: 0;
        }

        .noMar_label {
          padding-bottom: 0;
        }
      }
    }

    .div_btn {
      width: 100%;
      text-align: right;
      display: inline-block;
      margin-top: 12px;
    }
  }

  .ViewDP_sx_dialog {
    .noSelect;

    .dialog_count {
      display: inline-block;
      width: 100%;

      .count_div {
        width: 100%;
        display: inline-block;
        padding: 5px 0;

        > .div_label {
          width: 100%;
          padding: 57px 15px 10px;
          // border: 1px solid @borderColor;
          border-bottom: 0;
          position: relative;

          > span {
            width: 100%;
            display: inline-block;
            line-height: 40px;
            height: 42px;
            font-size: 16px;
            letter-spacing: 2px;
            font-weight: bold;
            margin-bottom: 7px;
            background: #eeeeee;
            padding: 0 15px;
            position: absolute;
            top: 0;
            left: 0;
            .noSelect;
          }

          .el-radio {
            margin-bottom: 15px;
          }

          .el-checkbox-group {
            margin-top: 10px;
            max-height: 200px;
            overflow-y: auto;
            overflow-x: hidden;

            .el-checkbox {
              margin-bottom: 10px;
              margin-right: 15px;
              width: calc((100% / 3) - 15px);

              .el-checkbox__input {
                float: left;
                margin-top: 1px;
                color: #000;
              }

              .el-checkbox__label {
                color: #000;
                width: calc(~"100% - 20px");
                float: left;
                display: inline-block;
                .text_oneLine;
              }
            }
          }
          .el-checkbox-group::-webkit-scrollbar {
            width: 4px;
            height: 4px;
          }
          /*定义滚动条轨道 内阴影+圆角*/
          .el-checkbox-group::-webkit-scrollbar-track {
            border-radius: 10px;
          }

          /*定义滑块 内阴影+圆角*/
          .el-checkbox-group::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #d2d2d2;
          }

          .el-date-editor {
            width: 400px;
          }

          .el-slider {
            padding: 0 10px;

            .el-slider__runway {
              margin: 10px 0;
            }

            .el-slider__marks-text {
              white-space: nowrap;
            }
          }

          .input_num_fil {
            display: inline-block;
            padding: 0 5px;
            width: 100%;
            margin-bottom: 10px;

            .el-input {
              width: calc((100% - 20px) / 2);

              .el-input__inner {
                text-align: center;
              }
            }

            .el-input:first-child {
              margin-right: 20px;
            }
          }

          .span_num_label {
            width: 100%;
            position: relative;
            padding: 0 10px;
            display: inline-block;

            .span_fir {
              display: inline-block;
              transform: translateX(-50%);
              min-width: 20px;
              text-align: center;
              font-weight: bold;
              font-size: 14px;
              float: left;
              height: 20px;
              line-height: 20px;
            }

            .span_las {
              display: inline-block;
              transform: translateX(50%);
              min-width: 20px;
              float: right;
              text-align: center;
              font-weight: bold;
              font-size: 14px;
              height: 20px;
              line-height: 20px;
            }
          }
        }

        .div_label:last-child {
          // border-bottom: 1px solid @borderColor;
          margin-bottom: 0;
        }

        .tjFil {
          padding: 40px 0 0;

          .oneAdd {
            margin: 5px 0 10px;
          }

          .for_tjFil {
            width: 100%;
            max-height: 330px;
            overflow-x: hidden;
            overflow-y: auto;
            padding: 15px 15px;

            .tjFilCoDiv {
              width: 100%;
              white-space: nowrap;
              height: 35px;
              margin-bottom: 10px;
              display: inline-block;

              > span {
                width: 130px;
                display: inline-block;
                line-height: 35px;
                margin-right: 15px;
                float: left;
                text-align: left;
                .text_oneLine;
              }

              .el-select {
                width: 120px;
                float: left;
                margin-right: 15px;

                .el-input {
                  // width: 100% !important;
                }

                .el-input__inner {
                  height: 35px;
                  line-height: 35px;
                }

                .el-input__icon {
                  line-height: 35px;
                }
              }

              .el-input {
                width: calc(100% - 350px);
                margin-right: 15px;
                float: left;

                .el-input__inner {
                  height: 35px;
                  line-height: 35px;
                }
              }

              .qj_item {
                width: calc((100% - 350px - 15px) / 2);
                margin-right: 15px;
              }

              .FSvg {
                float: left;
                margin-right: 15px;
                .com_middle;
              }

              .FSvg:last-child {
                margin-right: 0;
              }
            }

            .tjFilCoDiv:last-child {
              margin-bottom: 0;
            }
          }
        }

        .noMar_label {
          margin-bottom: 0;
          padding-bottom: 0;
        }
      }
    }

    .div_btn {
      width: 100%;
      text-align: right;
      display: inline-block;
      margin-top: 12px;
    }
  }
}

.createViewDP_pop_chart_chil {
  max-width: 400px;
  padding: 10px;

  .chart_chil {
    width: calc(100% + 5px);
    height: 100%;
    display: inline-block;

    .chart_d {
      width: 120px;
      margin-right: 5px;
      padding: 5px 5px 0;
      float: left;
      cursor: pointer;
      border: 1px dashed transparent;

      > img {
        width: 100%;
        max-height: 80px;
      }

      > span {
        text-align: center;
        display: inline-block;
        line-height: 20px;
        font-size: 12px;
        letter-spacing: 1px;
        width: 100%;
        .text_oneLine;
      }
    }

    .chart_d:hover {
      border: 1px dashed @green;
      border-radius: @borderRadio;
    }

    .addCharts {
      border: 1px dashed @green;
      border-radius: @borderRadio;
      background-color: hsl(@green, 5%);
    }
  }
}
.el-dialog .el-dialog__body {
  padding: 30px;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000 !important;
}
.el-checkbox__input + .el-checkbox__label {
  color: #000 !important;
}
.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}
</style>